import {
  Badge,
  Button,
  CssBaseline,
  Grid,
  IconButton,
  Paper,
  Snackbar,
  Tooltip,
  Popover,
  useMediaQuery,
  useTheme
} from "@mui/material";
import React, { useRef, useContext, useEffect, useMemo, useState } from "react";
import {
  LicenseInfo,
  DataGridPro,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  getGridStringOperators,
  getGridDateOperators
} from "@mui/x-data-grid-pro";
import saveAs from "file-saver";
import { CommonService } from "../../services";
import ChipInfoList from "../common/ChipInfoList";
import { LoggedInUserDetails } from "../common/LoggedInUserDetails/LoggedInUserDetails";
import Alert from "@mui/lab/Alert";
import RefreshIcon from "@mui/icons-material/Refresh";
import { CustomFilters } from "../common/CustomFilters/CustomFilters";
import useStyles from "../common/CommonStyle/CommonStyle";
import { FormattedMessage, useIntl } from "react-intl";
import GridTextLocalization from "../common/GridTextLocalization/GridTextLocalization";
import { SupportedLanguageDetails } from "../common/SupportedLanguageDetails/SupportedLanguageDetails";
import CommonGridPagination from "../common/CommonGridPagination/CommonGridPagination";
import { ModuleAccessPermissionKey } from "../../Constants/ModuleAccessKey";
import IconMessage from "@mui/icons-material/Forum";
import CustomBreadCrumb from "../common/CustomBreadCrumb";
import IconApproval from "@mui/icons-material/LibraryAddCheck";
import CancelIcon from "@mui/icons-material/Cancel";
import CustomReportIcon from "@mui/icons-material/Archive";
import CommonBackDrop from "../common/BackDrop";
import { GlobalEdiApiConstants } from "../../Constants/GlobalEdiApiConstants";
import CustomFilterComponent, {
  GetFilterableColumns
} from "../common/CustomFilterComponent";
import { FilterList, PersonPinCircleSharp } from "@mui/icons-material";
import { manageUserPreferences } from "../../services/manageUserPreferences";
import ConfirmationDialog from "../../components/common/ConfirmationDialog";
import ExploreIcon from "@mui/icons-material/Explore";
import EditIcon from "@mui/icons-material/EditOutlined";
import ImportIcon from "@mui/icons-material/SaveAlt";
import FileUploadSection from "./FileUploadSection";
import IosShareIcon from "@mui/icons-material/IosShare";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useHistory } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import {
  Dialog,
  DialogTitle,
  Popover as MuiPopover,

  DialogContent,
  DialogActions
} from "@mui/material";
import CustomsValuationFilterDialog from "./CustomsValuationFilterDialog/CustomsValuationFilterDialog";
import AdapterDayjs from "@mui/lab/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/lab";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const columnFieldsName = {
  organization: "organization",
  entity: "entity",
  custValId: "custValId",
  declareCls: "declareCls",
  judge: "judge",
  firstImportDate: "firstImportDate",
  remarks: "remarks",
  importDeclarationNo: "importDeclarationNo",
  importDeclarationDate: "importDeclarationDate",
  pic: "pic",
  section: "section",
  invoiceNo: "invoiceNo",
  soDate: "soDate",
  shipDate: "shipDate",
  custCode: "custCode",
  custDesc: "custDesc",
  acpNo: "acpNo",
  acpDate: "acpDate",
  supCode: "supCode",
  supDesc: "supDesc",
  acpClsDesc: "acpClsDesc",
  itemCode: "itemCode",
  generalDesc: "generalDesc",
  makerPartNo: "makerPartNo",
  custPartNo: "custPartNo",
  qty: "qty",
  unit: "unit",
  unitPrice: "unitPrice",
  amount: "amount",
  currency: "currency",
  project: "project",
  soNo: "soNo",
  soLineNo: "soLineNo",
  salesNo: "salesNo",
  salesLineNo: "salesLineNo",
  purNo: "purNo",
  purLineNo: "purLineNo",
  infoEmailDeliveryDate: "infoEmailDeliveryDate",
  alertEmailSentStatus: "alertEmailSentStatus",
  alertEmailSentDate: "alertEmailSentDate",
  recCls: "recCls",
  reasonForNoDeclareCls: "reasonForNoDeclareCls",
  createdTime: "createdTime",
  createdBy: "createdBy",
  updatedTime: "updatedTime",
  updatedBy: "updatedBy",
  orgCode: "organization.erpOrgCode",
  entityCode: "entity.erpEntityCode",
  orgName: "organization.orgName",
  entityName: "entity.entityName",
  latestDataSource: "latestDataSource",
  confirmationStatus: "confirmationStatus",
  confirmedBy: "confirmedBy",
  confirmedDate: "confirmedDate",
  evaluationEmailSentStatus: "evaluationEmailStatus",
  evaluationEmailSentDate: "evaluationEmailSentDate",
  alarmMailDeliveryDate: "alarmMailDeliveryDate",
  shipSoNo: "shipSoNo",
  shipDtSoDt: "shipDtSoDt"
};

function CustomsValuation(props) {
  const history = useHistory();
  const [createConfigDtl, setMode] = React.useState("");
  const [openFileUploadSection, setopenFileUploadSection] = useState(false);
  const classes = useStyles();
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const intl = useIntl();
  const theme = useTheme();
  const X_GRID_LICENSE_KEY = `${process.env.REACT_APP_X_GRID_LICENSE_KEY}`.toString();
  LicenseInfo.setLicenseKey(X_GRID_LICENSE_KEY);
  const selectedLanguage = useContext(SupportedLanguageDetails);
  const localtext = GridTextLocalization();
  const apiUrlAndParamBodyConstants = GlobalEdiApiConstants();
  const apiRef = useGridApiRef();
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const pageLabelsConstantsAndMessages = {
    alignment: {
      alignLeft: "left",
      alignRight: "right",
      alignCenter: "center"
    }
  };

  const primaryKeyRef = useRef(null);
  const [selectedRow, setSelectedRow] = React.useState([]);
  const moduleAccessKeyPermission = ModuleAccessPermissionKey();
  const { loggedInUserInfo } = useContext(LoggedInUserDetails);
  const editableFields = [
    "declareCls",
    "judge",
    "firstImportDate",
    "remarks",
    "importDeclarationNo",
    "importDeclarationDate",
    "reasonForNoDeclareCls"
  ];
  const customsModuleAccess =
    loggedInUserInfo.roleModuleAccess[
      moduleAccessKeyPermission.CustomsValuation
    ];
  const [openFileUploadDialog, setOpenFileUploadDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [alertBoxState, setAlertBoxState] = React.useState({
    openAlert: false,
    vertical: "top",
    horizontal: "center",
    message: "",
    severity: "info"
  });
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const handleCloseAlert = () => {
    setAlertBoxState({ ...alertBoxState, openAlert: false });
  };
  const mobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { vertical, horizontal, openAlert, message, severity } = alertBoxState;
  const [refreshTable, setRefreshTable] = useState(false);
  const [gridKey, setGridKey] = useState(0);
  const [tableLoadingStatus, setTableLoadingStatus] = useState(false);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [chipInfoList, setChipInfoList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [roleSubModuleAccess, setRoleSubModuleAccess] = useState([]);
  const [columns, setColumns] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [disableApproveButton, isDisableApproveButton] = useState(true);
  const [
    disiablingDownloadButtonForZeroRecords,
    setDisiablingDownloadButtonForZeroRecords
  ] = useState(false);
  const [keyValueData, setKeyValueData] = useState({});
  const [isRowSentForApproval, setIsRowSentForApproval] = useState(false);
  var defaultEntity = loggedInUserInfo.defaultEntity;
  console.log(defaultEntity);
  const [searchedErpEntityCode, setSearchedErpEntityCode] = useState(
    defaultEntity
  );

  // Load role submodule access on mount
 useEffect(() => {
  CommonService.GetListApi('/customsValuationSubModule')
    .then(response => {
      const access = response.data || [];
      setRoleSubModuleAccess(access);
      setRoleAccessLoaded(true);
    })
    .catch(() => {
      setRoleAccessLoaded(true);
    });
}, []);

  const hasAccess = buttonDescription => {
    if (!roleSubModuleAccess || roleSubModuleAccess.length === 0) {
      return false; // Show buttons if no access data yet
    }

    const access = roleSubModuleAccess.find(
      item => item.subModule?.description === buttonDescription
    );
    return access?.accessFlag === true;
  };

  const [searchedJudge, setSearchedJudge] = useState("");
  const [searchedBpType, setSearchedBpType] = useState("");
  const [searchedInvoiceNo, setSearchedInvoiceNo] = useState("");
  const [searchedBuyerPartyCode, setSearchedBuyerPartyCode] = useState("");
  const [searchedBuyerName, setSearchedBuyerName] = useState("");
  const [searchedSupplierPartyCode, setSearchedSupplierPartyCode] = useState(
    ""
  );
  const [searchedSupplierName, setSearchedSupplierName] = useState("");
  const [msgHdrPopUp, setMsgHdrPopUp] = useState(false);
  const [searchedMsgStatus, setSearchMsgStatus] = useState("");
  const [searchedCommType, setSearchedCommType] = useState("");
  const [disableRejectionButton, isDisableRejectionButton] = useState(true);
  const [openFilterPanel, setFilterPanel] = useState(false);
  const [searchedDeclareCls, setSearchedDeclareCls] = useState("");
  const [searchedFirstImportFrom, setSearchedFirstImportFrom] = useState("");
  const [searchedFirstImportTo, setSearchedFirstImportTo] = useState("");
  const [
    searchedImportDeclarationFrom,
    setSearchedImportDeclarationFrom
  ] = useState("");
  const [
    searchedImportDeclarationTo,
    setSearchedImportDeclarationTo
  ] = useState("");
  const [searchedCreatedFrom, setSearchedCreatedFrom] = useState("");
  const [searchedCreatedTo, setSearchedCreatedTo] = useState("");
  const [searchedPic, setSearchedPic] = useState("");
  const [searchedMakerPartNo, setSearchedMakerPartNo] = useState("");
  const [searchedOrgCode, setSearchedOrgCode] = useState("");
  const [searchedReasonForNotReq, setSearchedReasonForNotReq] = useState("");
  const [searchedRemarks, setSearchedRemarks] = useState("");
  const [searchedSoNo, setSearchedSoNo] = useState("");
  const [searchedItemCode, setSearchedItemCode] = useState("");
  const [searchedProject, setSearchedProject] = useState("");
  const [searchedConfirmationStatus, setSearchedConfirmationStatus] = useState(
    ""
  );
  const [
    searchedImportDeclarationNo,
    setSearchedImportDeclarationNo
  ] = useState("");
  const [searchedSection, setSearchedSection] = useState("");

  const handleClose = () => {
    setFilterPanel(false);
  };
  const [filterCount, setFilterCount] = React.useState();

  const [isEditMode, setIsEditMode] = useState(false);

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  const handleCancelEdit = () => {
    setIsEditMode(false);
  };

  const defaulSelectedFilters =
    [];

  const [selectedFilters, setSelectedFilters] = useState(defaulSelectedFilters);

  const [roleAccessLoaded, setRoleAccessLoaded] = useState(false);

  const [isSelectAllClicked, setIsSelectAllClicked] = useState(false);

  const [confirmationMode, setConfirmationMode] = useState("delete");
  const [bulkDeleteMode, setBulkDeleteMode] = useState(false);																 


  const [paramBody, setParamBody] = useState(
    apiUrlAndParamBodyConstants.paramBodyForGetListApis.customsValuation
  );

  const componentList = [
    {
      path: undefined,
      name: <FormattedMessage id="common.menu.breadcrumb.message" />,
      iconName: IconMessage
    },
    {
      path: "/CustomsValuation",
      name: <FormattedMessage id="common.module.breadcrumb.customsvaluation" />,
      iconName: ExploreIcon
    }
  ];

  const reasonOptions = [
    {
      label: "NULL (空白)",
      value: "NULL"
    },
    {
      label: "通常有償出荷物で輸入は無い",
      value: "通常有償出荷物で輸入は無い"
    },
    {
      label: "無償出荷物だが、この貨物を使用して製造した製品の輸入は無い",
      value: "無償出荷物だが、この貨物を使用して製造した製品の輸入は無い"
    },
    { label: "国内取引であり輸入は無い", value: "国内取引であり輸入は無い" },
    {
      label: "三国間取引であり輸入は無い",
      value: "三国間取引であり輸入は無い"
    },
    { label: "返品処理で輸入は無い", value: "返品処理で輸入は無い" },
    { label: "通常の輸入貨物", value: "通常の輸入貨物" },
    {
      label: "インボイス価格に含まれているので評価申告は不要",
      value: "インボイス価格に含まれているので評価申告は不要"
    },
    {
      label: "その他（詳細理由記載＆輸入に関わる費用か否かを記載）",
      value: "その他（詳細理由記載＆輸入に関わる費用か否かを記載）"
    }
  ];

  const declareOptions = [
    { label: "NULL (空白)", value: "NULL" },
    { label: "要", value: "01" },
    { label: "不要", value: "00" }
  ];

  const selectedRowsData = useMemo(() => {
    return tableData.filter(row => selectedRow.includes(row.custValId));
  }, [selectedRow, tableData]);

  const payloadToSend =
    selectedRowsData.length > 0 ? selectedRowsData : tableData;
  const [editingRowIds, setEditingRowIds] = useState([]);
  const [editedRowsMap, setEditedRowsMap] = useState({});
  const hasUnsavedChanges = () => {
    try {
      if (editedRowsMap && Object.keys(editedRowsMap).length > 0) return true;
      if (editingRowIds && editingRowIds.length > 0) return true;
      const editModel = apiRef.current?.getEditRowsModel?.();
      if (editModel && Object.keys(editModel).length > 0) return true;
    } catch (e) {}
    return false;
  };

  const isRowEdited = id => {
    if (id === undefined || id === null) return false;
    const idStr = String(id);
    const inEditedMap = editedRowsMap && Object.prototype.hasOwnProperty.call(editedRowsMap, idStr);
    const inEditingIds = editingRowIds && editingRowIds.map(String).includes(idStr);
    return Boolean(inEditedMap || inEditingIds);
  };

  // Validation state and helpers
  const [validationErrors, setValidationErrors] = useState({});

  // Header popover state for showing column validation messages
  const [headerPopoverAnchor, setHeaderPopoverAnchor] = useState(null);
  const [headerPopoverMsgs, setHeaderPopoverMsgs] = useState([]);
  const [headerPopoverField, setHeaderPopoverField] = useState("");

  const openHeaderPopover = (event, field, msgsArray) => {
    try {
      // stop grid header from handling the click (prevents sort/menu opening)
      if (event && event.stopPropagation) event.stopPropagation();
    } catch (e) {}
    setHeaderPopoverAnchor(event.currentTarget || event.target);
    setHeaderPopoverMsgs(Array.isArray(msgsArray) ? msgsArray : []);
    setHeaderPopoverField(field || "");
  };

  const closeHeaderPopover = () => {
    setHeaderPopoverAnchor(null);
    setHeaderPopoverMsgs("");
    setHeaderPopoverField("");
  };

  const utf8ByteLength = str => {
    try {
      if (str === null || str === undefined) return 0;
      return new TextEncoder().encode(String(str)).length;
    } catch (e) {
      // Fallback for older browsers
      return unescape(encodeURIComponent(String(str))).length;
    }
  };

const containsProhibitedChars = str => {
  if (str === null || str === undefined) return false;

  const s = String(str);
  const prohibitedRe = /['&%"\x00-\x1F\x7F]/u;

  return prohibitedRe.test(s);
};

  const isValidDateValue = value => {
    if (value === null || value === undefined || value === "") return true; // allow empty unless required elsewhere
    const d = new Date(value);
    return !(isNaN(d.getTime()));
  };

  const buildValidationKey = (id, field) => `${String(id)}__${String(field)}`;

  const setValidationForCell = (id, field, message) => {
    const key = buildValidationKey(id, field);
    setValidationErrors(prev => {
      const copy = { ...(prev || {}) };
      if (message && message.length > 0) {
        copy[key] = message;
      } else {
        if (copy.hasOwnProperty(key)) delete copy[key];
      }
      return copy;
    });
  };

  const hasValidationErrorsForIds = ids => {
    if (!validationErrors || Object.keys(validationErrors).length === 0) return false;
    const keys = Object.keys(validationErrors);
    return keys.some(k => {
      const [id] = k.split("__");
      return ids.map(String).includes(String(id));
    });
  };

  // Compute column-level error summaries from cell validationErrors
  const columnErrors = useMemo(() => {
    const map = {};
    try {
      Object.keys(validationErrors || {}).forEach(k => {
        const parts = String(k).split("__");
        const field = parts.length > 1 ? parts[1] : parts[0];
        const msg = validationErrors[k];
        if (msg && msg.length > 0) {
          if (!map[field]) map[field] = new Set();
          map[field].add(msg);
        }
      });
    } catch (e) {}
    return map;
  }, [validationErrors]);

  const erroredFields = useMemo(() => new Set(Object.keys(columnErrors || {})), [columnErrors]);

  const columnsWithHeaderErrors = useMemo(() => {
    try {
      return (columns || []).map(col => {
        if (!col) return col;
        if (erroredFields.has(col.field)) {
          // build detailed per-row messages for this column but limit to rows currently in the table (current page)
          const currentPageIds = (tableData || []).map(r => String(r.custValId));
          const details = Object.keys(validationErrors || {})
            .map(k => {
              const parts = String(k).split("__");
              const id = parts[0];
              const field = parts[1];
              return { key: k, id: String(id), field, msg: validationErrors[k] };
            })
            .filter(d => d.field === col.field && currentPageIds.includes(String(d.id)));

          const count = details.length;
          const msgs = details.map(d => `${d.id}: ${d.msg}`).join("\n");

          // Only show the header icon if there are errors on the current page
          if (count === 0) return col;

          // If the column is editable, increase its width so header icon and messages fit
          const minWidthForError = 220;
          const newCol = { ...col };
          if (col.editable) {
            newCol.width = Math.max(col.width || 120, minWidthForError);
          }

          return {
            ...newCol,
            renderHeader: params => (
              <div style={{ position: "relative", paddingRight: 28, display: "flex", alignItems: "center" }}>
                <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}>{col.renderHeader ? col.renderHeader(params) : col.headerName}</div>
                <div style={{ position: "absolute", right: 2, top: "50%", transform: "translateY(-50%)" }}>
                  <IconButton
                    size="small"
                    onClick={e => openHeaderPopover(e, col.field, details)}
                    onMouseDown={e => e.stopPropagation()}
                    aria-label={`validation-${col.field}`}
                    style={{ backgroundColor: "transparent", color: "#c62828", minWidth: 20, height: 20, padding: 2 }}
                  >
                    <Badge badgeContent={count} color="error" overlap="circular">
                      <ErrorOutlineIcon style={{ fontSize: 14 }} />
                    </Badge>
                  </IconButton>
                </div>
              </div>
            )
          };
        }
        return col;
      });
    } catch (e) {
      return columns;
    }
  }, [columns, columnErrors, erroredFields, tableData, validationErrors]);

  // Prompt user when running actions that might discard unsaved changes.
  // showWarning must be explicitly true to display the global warning.
  const runOrPrompt = (action, showWarning = false) => {
    if (hasUnsavedChanges()) {
      if (showWarning) {
        console.debug("runOrPrompt: blocking action due to unsaved changes", { showWarning });
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: (
            <FormattedMessage id="custom.warning.unsavedChanges" defaultMessage="Unsaved changes present. Please save changes before proceeding." />
          ),
          severity: "warning"
        });
      }
      return;
    }
    action && action();
  };

  const showDownloadPopUp = filePath => {
    setOpenBackDrop(true);
    const filePathReplaceWithDoubleBackwardSlash = filePath.replaceAll(
      "\\",
      "/"
    );
    const fileName = filePathReplaceWithDoubleBackwardSlash
      .split("/")
      [filePathReplaceWithDoubleBackwardSlash.split("/").length - 1].trim();
    fetch(
      `${process.env.REACT_APP_API_URL}/downloadFileFromServer?filePath=${filePathReplaceWithDoubleBackwardSlash}`,
      {
        method: "GET",
        headers: {
          authorization: "Bearer " + CommonService.getJwtTokenOfLoggedInUser()
        }
      }
    )
      .then(response => {
        return response.blob();
      })
      .then(blob => {
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: "Record Downloaded Successfully!",
          severity: "success"
        });
        saveAs(blob, fileName);
        setOpenBackDrop(false);
      })
      .catch(error => {
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: (
            <FormattedMessage
              id="errorMessage.download"
              defaultMessage="Failed to download the file!"
            />
          ),
          severity: "error"
        });
        setOpenBackDrop(false);
      });
  };

  // Stop edit mode and remove pending edits for any rows that are no longer selected
  const cleanupEditsForDeselected = () => {
    try {
      const editIds = (editingRowIds || []).map(id => String(id));
      const selectedIds = (selectedRow || []).map(id => String(id));
      const deselected = editIds.filter(id => !selectedIds.includes(id));
      if (deselected.length === 0) return;

      // Remove pending edited data for deselected rows
      setEditedRowsMap(prevMap => {
        const copy = { ...prevMap };
        deselected.forEach(did => {
          if (copy.hasOwnProperty(did)) delete copy[did];
        });
        return copy;
      });

      // Remove them from editingRowIds
      setEditingRowIds(prevIds => (prevIds || []).filter(id => !deselected.includes(String(id))));

      // Ask the grid to stop row edit mode for these ids
      try {
        // If cell-level edits are active, force each edited cell back to view mode first
        const editModel = apiRef.current?.getEditRowsModel?.();
        deselected.forEach(did => {
          try {
            if (editModel && editModel[did]) {
              Object.keys(editModel[did]).forEach(field => {
                try {
                  if (apiRef.current.setCellMode) {
                    apiRef.current.setCellMode(did, field, "view");
                  }
                  // Some grid versions support stopCellEditMode
                  if (apiRef.current.stopCellEditMode) {
                    try {
                      apiRef.current.stopCellEditMode({ id: isNaN(did) ? did : Number(did), field });
                    } catch (e) {}
                  }
                } catch (e) {}
              });
            }

            if (apiRef.current.stopRowEditMode) {
              apiRef.current.stopRowEditMode({ id: isNaN(did) ? did : Number(did) });
            }
          } catch (e) {}
        });
      } catch (e) {}
    } catch (e) {}
  };

  const handleRefresh = () => {
    // Blur active element so the grid processes any pending cell edits
    try {
      if (document && document.activeElement && typeof document.activeElement.blur === "function") {
        document.activeElement.blur();
      }
    } catch (e) {}

    // First run the existing deselected cleanup
    cleanupEditsForDeselected();

    // Additionally, aggressively stop any remaining row/cell edit modes for all tracked ids
    try {
      const editIdsFromState = (editingRowIds || []).map(id => String(id));
      const editIdsFromMap = Object.keys(editedRowsMap || {}).map(id => String(id));
      const allIds = Array.from(new Set([...editIdsFromState, ...editIdsFromMap]));

      // Try to stop cell edits and row edit mode for each id
      allIds.forEach(did => {
        try {
          const editModel = apiRef.current?.getEditRowsModel?.();
          if (editModel && editModel[did]) {
            Object.keys(editModel[did]).forEach(field => {
              try {
                if (apiRef.current.setCellMode) apiRef.current.setCellMode(did, field, "view");
                if (apiRef.current.stopCellEditMode) apiRef.current.stopCellEditMode({ id: isNaN(did) ? did : Number(did), field });
              } catch (e) {}
            });
          }

          if (apiRef.current.stopRowEditMode) {
            apiRef.current.stopRowEditMode({ id: isNaN(did) ? did : Number(did) });
          }
        } catch (e) {}
      });
    } catch (e) {}

    // Clear local edit tracking state and exit edit mode
    try {
      setEditedRowsMap({});
      setEditingRowIds([]);
      // Clear validation errors on refresh so visual highlights reset
      setValidationErrors({});
      setIsEditMode(false);
    } catch (e) {}

    // Bump grid key to force remount if the grid still shows edit UI; also refresh table data
    setTimeout(() => {
      setGridKey(k => k + 1);
      setRefreshTable(prev => !prev);
    }, 80);
  };

function currentlySelectedRow(selections) {
  const visibleRowIds = tableData.map(row => row.custValId);
  const previousCount = selectedRow.length;
  const newCount = selections.length;
  const selectionDiff = Math.abs(newCount - previousCount);
  
  // Individual click = exactly 1 row changed
  // Select All = multiple rows changed at once (jump to all visible)
  if (selectionDiff === 1) {
    // User clicked individual checkbox - always keep isSelectAllClicked false
    setIsSelectAllClicked(false);
  } else if (selectionDiff > 1 && newCount === visibleRowIds.length) {
    // Bulk selection (Select All clicked)
    setIsSelectAllClicked(true);
  } else if (newCount === 0) {
    // Deselected all
    setIsSelectAllClicked(false);
  }
  
    // Remove edited data for any rows that were deselected (unchecked)
    try {
      const prev = selectedRow.map(String);
      const now = selections.map(String);
      const deselected = prev.filter(id => !now.includes(id));
      if (deselected && deselected.length > 0) {
        cleanupDeselectedIds(deselected);
      }
    } catch (e) {}

  setSelectedRow(selections);
}

  const handleExportAndSend = () => {
    // Export selected rows if any are selected (this covers per-row and page 'select all').
    // If nothing is selected, export all filtered records across pages.
    let parameters = {};
    const { pageNo, recordsPerPage, ...filterParams } = paramBody;
    setIsEditMode(false);

    if (selectedRow && selectedRow.length > 0) {
      // Export only selected rows (including when user used the page "select all")
      parameters = {
        custValIds: selectedRow,
        ...filterParams
      };
      console.log(`Exporting ${selectedRow.length} selected record(s)`);
    } else {
      // No explicit selection: export all filtered records across pages
      parameters = {
        ...filterParams,
        exportAll: true
      };
      console.log("Exporting all filtered records (no selection)");
    }

    setOpenBackDrop(true);

    console.log("Export parameters:", parameters);

    CommonService.saveOrUpdateOrPost("/submit", parameters)
      .then(response => {
        console.log("Backend response:", response);

        if (response.data && response.data.filePath) {
          const filePath = response.data.filePath;

          showDownloadPopUp(filePath);

          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: "Successfully exported selected record(s)",
            severity: "success"
          });

          setSelectedRow([]);
        }

        setOpenBackDrop(false);
      })
      .catch(error => {
        console.error("Failed to export data:", error);

        const errorMessage =
          error?.response?.data?.message ||
          "Failed to export. Please try again.";

        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: errorMessage,
          severity: "error"
        });

        setOpenBackDrop(false);
      });
  };

  

  const [openReportDownloadDialog, setOpenReportDownloadDialog] = useState(
    false
  );
  const [proccessValue, setProcessValue] = useState("");
  const [bpTypeValue, setBpTypeValue] = useState("");
  const [entityValue, setEntityValue] = useState("");
  const [primaryKeyOfSelectedRow, setPrimaryKeyOfSelectedRow] = useState(0);
  const [msgIdvalue, setMsgIdValue] = useState("");

  const closeReportDownloadDialog = confirmed => {
    setOpenReportDownloadDialog(false);
  };

  const [
    callSaveApiForOrderVisibility,
    setCallSaveApiForOrderVisibility
  ] = useState(false);
  const [callSaveApiForSorting, setCallSaveApiForSorting] = useState(false);
  const [preference, setPreference] = useState(
    apiUrlAndParamBodyConstants.paramBodyForGetListApis.userPreference
  );
  const [pinnedColumns, setPinnedColumns] = useState({
    left: ["__check__"],
    right: []
  });
  const [callSaveApiForPinning, setCallSaveApiForPinning] = useState(false);
  const [callSaveApiForFilter, setCallSaveApiForFilter] = useState(false);
  const [intialParamBodyApiCall, setIntialParamBodyApiCall] = useState(false);
  const [skipNextFilterEffect, setSkipNextFilterEffect] = useState(false);
  const [componentMountTrigger, setComponentMountTrigger] = useState(0);

  // Reset preference loading on component mount/remount to ensure data loads when navigating back
  useEffect(() => {
    // Trigger preference reload on mount/remount
    setComponentMountTrigger(prev => prev + 1);
  }, []);

  function orderAndHideColumns(savedUserPreference, defaultUserPreference) {
    if (
      savedUserPreference.length !== 0 &&
      defaultUserPreference.length !== 0
    ) {
      var orderedUserPreferences = [],
        len = defaultUserPreference.length,
        len_copy = len,
        index,
        current;

      for (; len--; ) {
        current = defaultUserPreference[len];
        index = savedUserPreference.findIndex(
          element => element.field === current.field
        );
        orderedUserPreferences[index] = current;
        orderedUserPreferences[index].hide = savedUserPreference[index].hide;
      }

      Array.prototype.splice.apply(
        defaultUserPreference,
        [0, len_copy].concat(orderedUserPreferences)
      );
      return orderedUserPreferences;
    }
  }

  // Immediately cleanup specific deselected ids: remove edited data and stop edit mode
  const cleanupDeselectedIds = deselected => {
    if (!deselected || deselected.length === 0) return;

    // remove from editedRowsMap
    setEditedRowsMap(prevMap => {
      const copy = { ...prevMap };
      deselected.forEach(did => {
        if (copy.hasOwnProperty(did)) delete copy[did];
      });
      return copy;
    });

    // remove from editingRowIds
    setEditingRowIds(prevIds => (prevIds || []).filter(id => !deselected.includes(String(id))));

    // remove any validation errors for these deselected ids
    try {
      setValidationErrors(prev => {
        if (!prev) return {};
        const copy = { ...prev };
        Object.keys(copy).forEach(k => {
          const [id] = String(k).split("__");
          if (deselected.map(String).includes(String(id))) delete copy[k];
        });
        return copy;
      });
    } catch (e) {}

    // Aggressively force any cell edit to commit/exit and stop row edit mode.
    // Retry a few times to handle timing/race conditions when focus remains inside the grid.
    try {
      // blur active element first
      try {
        if (document && document.activeElement && typeof document.activeElement.blur === "function") {
          document.activeElement.blur();
        }
      } catch (e) {}

      const attemptStop = (did, attempt = 0) => {
        try {
          const editModel = apiRef.current?.getEditRowsModel?.();
          if (editModel && editModel[did]) {
            Object.keys(editModel[did]).forEach(field => {
              try {
                if (apiRef.current.setCellMode) apiRef.current.setCellMode(did, field, "view");
                if (apiRef.current.stopCellEditMode) apiRef.current.stopCellEditMode({ id: isNaN(did) ? did : Number(did), field });
              } catch (e) {}
            });
          }

          if (apiRef.current.stopRowEditMode) {
            apiRef.current.stopRowEditMode({ id: isNaN(did) ? did : Number(did) });
          }
        } catch (e) {}

        // If after a short delay the row still appears editable, retry a couple times
        if (attempt < 1) {
          setTimeout(() => attemptStop(did, attempt + 1), 100 + attempt * 100);
        }
      };

      deselected.forEach(did => attemptStop(did, 0));
    } catch (e) {}
  };

  const DateEditInput = ({ params }) => {
    const [value, setValue] = React.useState(() =>
      params.value ? dayjs(params.value) : null
    );

    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={value}
          onChange={newValue => {
            setValue(newValue);
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: newValue ? newValue.toISOString() : null
            });
          }}
          renderInput={params => (
            // Show validation error/helper text when present
            (() => {
              const key = buildValidationKey(params.id, params.field);
              const msg = validationErrors && validationErrors[key] ? validationErrors[key] : "";
              return (
                <TextField
                  {...params}
                  fullWidth
                  size="small"
                  error={Boolean(msg)}
                  helperText={msg}
                  style={{ backgroundColor: "white" }}
                  InputProps={{ ...params.InputProps, style: { ...params.InputProps?.style, backgroundColor: "white" } }}
                />
              );
            })()
          )}
          inputFormat="YYYY-MM-DD"
        />
      </LocalizationProvider>
    );
  };

  // Generic text edit cell that shows validation errors as helper text
  const TextEditCell = ({ params, maxBytes = 0 }) => {
    const initial = params.props?.value ?? params.value ?? "";
    const [value, setValue] = React.useState(initial);

    React.useEffect(() => {
      setValue(initial);
    }, [initial]);

    const validateAndSet = v => {
      let msg = "";
      // if (v && containsProhibitedChars(v)) {
      //   msg = "Prohibited characters are not allowed.";
      // } else 
      if (maxBytes > 0 && v && v.length > maxBytes) {
        msg = `Maximum ${maxBytes} characters allowed.`;
      }
      setValidationForCell(params.id, params.field, msg);
      params.api.setEditCellValue({ id: params.id, field: params.field, value: v });
    };

    return (
      <TextField
        value={value}
        onChange={e => {
          setValue(e.target.value);
          validateAndSet(e.target.value);
        }}
        fullWidth
        size="small"
        error={Boolean(validationErrors && validationErrors[buildValidationKey(params.id, params.field)])}
        helperText={validationErrors && validationErrors[buildValidationKey(params.id, params.field)]}
        style={{ backgroundColor: "white" }}
        InputProps={{ style: { backgroundColor: "white" } }}
      />
    );
  };

  const savePreference = (preferenceChangeIn, params, orderedColumns) => {
    if (preferenceChangeIn === "filter") {
      setCallSaveApiForFilter(true);
      setPreference(prev => ({ ...prev, columnsFilter: params }));
    } else if (preferenceChangeIn === "sort") {
      setCallSaveApiForSorting(true);
      setPreference(prev => ({
        ...prev,
        columnsSort: { field: params.field, sort: params.sort }
      }));
    } else if (
      preferenceChangeIn === "visibility" ||
      preferenceChangeIn === "order"
    ) {
      var splicedFirstColumn = params;
      if (params[0].field === "__check__")
        splicedFirstColumn = params.splice(1, params.length);
      setCallSaveApiForOrderVisibility(true);
      setPreference(prev => ({
        ...prev,
        columnsOrdervisible: splicedFirstColumn
      }));
    } else if (preferenceChangeIn === "pinned") {
      setCallSaveApiForPinning(true);
      setPreference(prev => ({
        ...prev,
        columnsOrdervisible: orderedColumns,
        columnsPinned: params
      }));
    }
  };

  useEffect(() => {
    manageUserPreferences
      .saveLastOpenedScreen(componentList[1].name.props.id)
      .then(response => {})
      .catch(function(error) {
        if (error.response !== undefined) {
          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: error.response.data.message,
            severity: "error"
          });
        }
      });
  }, []);

  useEffect(() => {
    if (callSaveApiForPinning === false)
      preference.columnsPinned = pinnedColumns;
    if (callSaveApiForFilter === false)
      preference.columnsFilter = selectedFilters;
    if (
      callSaveApiForOrderVisibility === false &&
      callSaveApiForPinning === false
    )
      preference.columnsOrdervisible = columns;
    if (callSaveApiForSorting === false)
      preference.columnsSort = {
        field: paramBody.sortKey,
        sort: paramBody.sortDir
      };
    if (
      (callSaveApiForFilter === true ||
        callSaveApiForPinning === true ||
        callSaveApiForOrderVisibility === true ||
        callSaveApiForSorting === true) &&
      (preference.columnsOrdervisible !== undefined &&
        preference.columnsOrdervisible !== null &&
        preference.columnsOrdervisible?.length !== 0 &&
        preference.columnsSort.field !== "")
    ) {
      manageUserPreferences
        .saveGridPreferences({
          userId: 0,
          organization: {},
          entity: {},
          screenName: componentList[1].name.props.id,
          tabName: componentList[1].name.props.id,
          preferences: JSON.stringify(preference),
          lastOpen: true
        })
        .then(response => {
          if (callSaveApiForOrderVisibility === true) {
            var defaultColumns = columns;
            var userChangedColumns = preference.columnsOrdervisible;
            var userPreferedColumns = orderAndHideColumns(
              userChangedColumns,
              defaultColumns
            );
            setColumns(userPreferedColumns);
            setCallSaveApiForOrderVisibility(false);
          } else if (callSaveApiForSorting === true) {
            setCallSaveApiForSorting(false);
          } else if (callSaveApiForPinning === true) {
            setPinnedColumns(preference.columnsPinned);
            setColumns(preference.columnsOrdervisible);
            setCallSaveApiForPinning(false);
          } else if (callSaveApiForFilter === true) {
            setCallSaveApiForFilter(false);
          }
        })
        .catch(function(error) {
          if (error.response !== undefined) {
            setAlertBoxState({
              ...alertBoxState,
              openAlert: true,
              message: error.response.data.message,
              severity: "error"
            });
          }
        });
    }
  }, [preference]);

  useEffect(() => {
    setSortModel(paramBody.sortKey ? [{ field: paramBody.sortKey, sort: paramBody.sortDir }] : []);
  }, [paramBody.sortKey, paramBody.sortDir]);

  const commonColumnForCustomsValuation = useMemo(
    () => [
      {
        field: columnFieldsName.organization,
        headerName: intl.formatMessage({
          id: "columnname.organizationcode.label"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 100,
        type: "string",
        hide: true,
        filterable: false,
        valueGetter: params => `${params.row.organization.erpOrgCode}`,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.entity,
        headerName: intl.formatMessage({ id: "columnname.entitycode.label" }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 60,
        sortable: false,
        type: "string",
        hide: true,
        filterable: true,
        valueGetter: params => `${params.row.entity.erpEntityCode}`,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.declareCls,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.necessaryOrUnnecessary"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 135,
        sortable: false,
        editable: true,
        type: "string",
        hide: false,
        filterable: true,
        // valueGetter: (params) => `${params.row.entity.erpEntityCode}`,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: CommonService.CustomsValuationDeclareClsChip,
        renderEditCell: params => {
          const isConfirmed =
            params.row.confirmationStatus === 1 ||
            params.row.confirmationStatus === true;
          return (
            <DeclareClsDropDown
              id={params.id}
              field={params.field}
              value={params.value}
              api={params.api}
              row={params.row}
              disabled={isConfirmed}
            />
          );
        }
      },
      {
        field: columnFieldsName.judge,
        width: 120,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.judge"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        sortable: false,
        type: "string",
        editable: true,
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderEditCell: params => <TextEditCell params={params} maxBytes={20} />
        //valueGetter: (params) => `${params.row.fileName}`,
      },
      {
        field: columnFieldsName.firstImportDate,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.firstImportDate"
        }),
        type: "date",
        editable: true,
        width: 170,
        renderHeader: CommonService.customRenderHeaderColumns,
        // DateEditInput already displays validation messages from validationErrors
        renderEditCell: params => <DateEditInput params={params} />,
        renderCell: cellParams => {
          const rawDate = cellParams.row.firstImportDate;

          if (!rawDate) return <span></span>;

          const date = new Date(rawDate);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
          const day = String(date.getDate()).padStart(2, "0");

          const formattedDate = `${year}-${month}-${day}`;

          return <span>{formattedDate}</span>;
        },
        renderEditCell: params => <DateEditInput params={params} />
      },
      {
        field: columnFieldsName.reasonForNoDeclareCls,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.reasonForNoDeclareCls"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 250,
        sortable: false,
        type: "string",
        hide: false,
        editable: true,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderEditCell: params => {
          const isConfirmed =
            params.row.confirmationStatus === 1 ||
            params.row.confirmationStatus === true;

          // Determine declareCls taking into account any in-progress edits so
          // selecting "不要" enables the reason immediately without extra clicks.
          let declareVal = params.row?.declareCls;
          try {
            const editModel = params.api.getEditRowsModel && params.api.getEditRowsModel();
            const pending = editModel && editModel[params.id] && editModel[params.id].declareCls && editModel[params.id].declareCls.value;
            if (pending !== undefined && pending !== null) declareVal = pending;
          } catch (e) {}

          const notShowReason = declareVal !== "00";

          return (
            <ReasonDropdownEditCell
              id={params.id}
              field={params.field}
              value={params.value}
              api={params.api}
              row={params.row}
              disabled={isConfirmed || notShowReason}
            />
          );
        },
        renderCell: cellParams => {
          // Show the reason only when declareCls explicitly equals "不要"
          if (cellParams.row?.declareCls === "00") {
            return <span>{cellParams.row.reasonForNoDeclareCls || ""}</span>;
          }
          return <span></span>;
        }
      },
      {
        field: columnFieldsName.remarks,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.remarks"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 100,
        sortable: false,
        type: "string",
        editable: true,
        hide: false,
        filterable: false,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderEditCell: params => <TextEditCell params={params} maxBytes={256} />
        // renderCell: (cellParams) => (<span>{cellParams.row.updatedTimeDtDisp}</span>)
      },
      {
        field: columnFieldsName.importDeclarationNo,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.importDeclarationNo"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: true,
        editable: true,
        type: "string",
        hide: false,
        filterable: false,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderEditCell: params => <TextEditCell params={params} maxBytes={20} />
      },
      {
        field: columnFieldsName.importDeclarationDate,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.importDeclarationDate"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 135,
        sortable: true,
        type: "dateTime",
        editable: true,
        hide: false,
        filterable: false,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderEditCell: params => <DateEditInput params={params} />,
        renderCell: cellParams => {
          const rawDate = cellParams.row.importDeclarationDate;

          if (!rawDate) return <span></span>;

          const date = new Date(rawDate);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
          const day = String(date.getDate()).padStart(2, "0");

          const formattedDate = `${year}-${month}-${day}`;

          return <span>{formattedDate}</span>;
        },
        renderEditCell: params => <DateEditInput params={params} />
      },
      {
        field: columnFieldsName.pic,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.personInCharge"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: false,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.section,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.section"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: false,
        type: "string",
        hide: false,
        filterable: false,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.invoiceNo,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.invoiceNo"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 120,
        sortable: true,
        type: "string",
        hide: false,
        filterable: false,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.shipSoNo,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.ShipNo/SoNo"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 150,
        sortable: true,
        type: "string",
        hide: false,
        filterable: false,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.shipDtSoDt,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.ShipDate/SoDate"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 150,
        sortable: true,
        type: "dateTime",
        hide: false,
        filterable: false,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: cellParams => {
          const rawDate = cellParams.row.shipDtSoDt;

          if (!rawDate) return <span></span>;

          const date = new Date(rawDate);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
          const day = String(date.getDate()).padStart(2, "0");

          const formattedDate = `${year}-${month}-${day}`;

          return <span>{formattedDate}</span>;
        }
      },
      {
        field: columnFieldsName.soDate,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.soDate"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: true,
        type: "dateTime",
        hide: false,
        filterable: false,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: cellParams => {
          const rawDate = cellParams.row.soDate;

          if (!rawDate) return <span></span>;

          const date = new Date(rawDate);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
          const day = String(date.getDate()).padStart(2, "0");

          const formattedDate = `${year}-${month}-${day}`;

          return <span>{formattedDate}</span>;
        }
      },
      {
        field: columnFieldsName.shipDate,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.shipDate"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: true,
        type: "dateTime",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: cellParams => {
          const rawDate = cellParams.row.shipDate;

          if (!rawDate) return <span></span>;

          const date = new Date(rawDate);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
          const day = String(date.getDate()).padStart(2, "0");

          const formattedDate = `${year}-${month}-${day}`;

          return <span>{formattedDate}</span>;
        }
      },
      {
        field: columnFieldsName.custCode,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.custCode"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 130,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.custDesc,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.custDesc"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 130,
        sortable: false,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.acpNo,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.acpNo"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: true,
        editable: true,
        type: "string",
        hide: false,
        filterable: false,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.acpDate,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.acpDate"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: true,
        type: "dateTime",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: cellParams => {
          const rawDate = cellParams.row.acpDate;

          if (!rawDate) return <span></span>;

          const date = new Date(rawDate);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
          const day = String(date.getDate()).padStart(2, "0");

          const formattedDate = `${year}-${month}-${day}`;

          return <span>{formattedDate}</span>;
        }
      },
      {
        field: columnFieldsName.supCode,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.supCode"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.supDesc,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.supDesc"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: false,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.acpClsDesc,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.acpClsDesc"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 135,
        sortable: false,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.itemCode,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.itemCode"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.generalDesc,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.generalDesc"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 135,
        sortable: false,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.makerPartNo,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.makerPartNo"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 135,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.custPartNo,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.custPartNo"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 135,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.qty,
        headerName: intl.formatMessage({ id: "columnname.messageNumber.qty" }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 65,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.unit,
        headerName: intl.formatMessage({ id: "columnname.messageNumber.unit" }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 70,
        sortable: false,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.unitPrice,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.unitPrice"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.amount,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.amount"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 80,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.currency,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.currency"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: false,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.project,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.project"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.soNo,
        headerName: intl.formatMessage({ id: "columnname.messageNumber.soNo" }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 90,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.soLineNo,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.soLineNo"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 110,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.salesNo,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.salesNo"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 90,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.salesLineNo,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.salesLineNo"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 125,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.purNo,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.purNo"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 90,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.purLineNo,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.purLineNo"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 125,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.infoEmailDeliveryDate,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.infoEmailDeliveryDate"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 230,
        sortable: true,
        type: "string",
        hide: true,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: cellParams => {
          const rawDate = cellParams.row.infoEmailDeliveryDate;

          if (!rawDate) return <span></span>;

          const date = new Date(rawDate);

          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
          const day = String(date.getDate()).padStart(2, "0");

          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");

          const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

          return <span>{formattedDateTime}</span>;
        }
      },
      {
        field: columnFieldsName.alertEmailSentStatus,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.alertEmailSentStatus"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 230,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: CommonService.CustomsValuationAlertStatusChip
      },
      {
        field: columnFieldsName.alertEmailSentDate,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.alertEmailSentDate"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 215,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: cellParams => {
          const rawDate = cellParams.row.alertEmailSentDate;

          if (!rawDate) return <span></span>;

          const date = new Date(rawDate);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
          const day = String(date.getDate()).padStart(2, "0");

          const formattedDate = `${year}-${month}-${day}`;

          return <span>{formattedDate}</span>;
        }
      },
      {
        field: columnFieldsName.recCls,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.recCls"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 90,
        sortable: false,
        type: "string",
        hide: true,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.confirmationStatus,
        width: 200,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.confirmationStatus"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: CommonService.ConfirmationStatusChips
      },
      {
        field: columnFieldsName.confirmedBy,
        headerName: intl.formatMessage({
          id: "common.label.confirmedBy"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 135,
        sortable: false,
        type: "string",
        hide: false,
        renderHeader: CommonService.customRenderHeaderColumns
      },
      {
        field: columnFieldsName.confirmedDate,
        headerName: intl.formatMessage({
          id: "common.label.confirmedDate"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 155,
        sortable: true,
        type: "string",
        hide: false,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: cellParams => {
          const rawDate = cellParams.row.confirmedDate;

          if (!rawDate) return <span></span>;

          const date = new Date(rawDate);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
          const day = String(date.getDate()).padStart(2, "0");

          const formattedDate = `${year}-${month}-${day}`;

          return <span>{formattedDate}</span>;
        }
      },
      {
        field: columnFieldsName.evaluationEmailSentStatus,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.EvaluationEmailSentStatus"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 380,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: CommonService.CustomsValuationConfirmationEmailStatusChip
      },
      {
        field: columnFieldsName.evaluationEmailSentDate,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.EvaluationalertEmailSentDate"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 350,
        sortable: true,
        type: "string",
        hide: false,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: cellParams => {
          const rawDate = cellParams.row.evaluationEmailSentDate;

          if (!rawDate) return <span></span>;

          const date = new Date(rawDate);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
          const day = String(date.getDate()).padStart(2, "0");

          const formattedDate = `${year}-${month}-${day}`;

          return <span>{formattedDate}</span>;
        }
      },
      {
        field: columnFieldsName.createdTime,
        headerName: intl.formatMessage({
          id: "common.label.createdDate"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 145,
        sortable: true,
        type: "string",
        hide: false,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: (cellParams) => {
          const rawDate = cellParams.row.createdTime;

          if (!rawDate) return <span></span>;

          const date = new Date(rawDate);

          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");

          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");

          const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

          return <span>{formattedDateTime}</span>;
        }
      },
      {
        field: columnFieldsName.updatedTime,
        headerName: intl.formatMessage({
          id: "common.label.updatedDate"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 145,
        sortable: true,
        type: "string",
        hide: false,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: (cellParams) => {
          const rawDate = cellParams.row.updatedTime;

          if (!rawDate) return <span></span>;

          const date = new Date(rawDate);

          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");

          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");

          const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

          return <span>{formattedDateTime}</span>;
        }
      },
      {
        field: columnFieldsName.alarmMailDeliveryDate,
        headerName: intl.formatMessage({
          id: "columnname.messageNumber.alarmMailDeliveryDate"
        }),
        headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
        align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
        width: 230,
        sortable: true,
        type: "string",
        hide: true,
        filterable: true,
        renderHeader: CommonService.customRenderHeaderColumns,
        renderCell: cellParams => {
          const rawDate = cellParams.row.alarmMailDeliveryDate;

          if (!rawDate) return <span></span>;

          const date = new Date(rawDate);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
          const day = String(date.getDate()).padStart(2, "0");

          const formattedDate = `${year}-${month}-${day}`;

          return <span>{formattedDate}</span>;
        }
      }
    ],
    [roleSubModuleAccess, intl, classes, apiRef]
  );

  const handleRowUpdate = (newRow, oldRow) => {
    // Do not save changes here
    return oldRow; // temporarily revert unless Save is clicked
  };

  const handleRowUpdateError = error => {
    console.error("Error during row update:", error);
  };

  const handleDelete = primaryKey => {
    primaryKeyRef.current = primaryKey;
    setConfirmationMessage(
      <FormattedMessage id="snackbar.recordDeleteForCustomsValuation" />
    );
    setOpenConfirmationDialog(true);
  };

  const handleBulkDelete = () => {
    // Only allow delete when user has selected one or more rows.
    if (!selectedRow || selectedRow.length === 0) {
      setAlertBoxState({
        ...alertBoxState,
        openAlert: true,
        message: (
          <FormattedMessage
            id="snackbar.selectRecordToDelete"
            defaultMessage="Please select at least one record to delete."
          />
        ),
        severity: "warning"
      });
      return;
    }

    // mark bulk delete mode and store ids in primaryKeyRef for reuse
    setBulkDeleteMode(true);
    setIsEditMode(false);
    primaryKeyRef.current = selectedRow.slice();
    setConfirmationMessage(
      <FormattedMessage
        id="snackbar.confirmDeleteSelected"
        defaultMessage="Are you sure you want to delete the selected records?"
      />
    );
    setConfirmationMode("delete");
    setOpenConfirmationDialog(true);
  };

  const closeConfirmationDialog = confirmed => {
    setOpenConfirmationDialog(false);
        if (confirmed) {
      const primaryKey = primaryKeyRef.current;
      // If confirmationMode is 'save', perform save of edited rows
      if (confirmationMode === "save") {
        const candidateUpdates = primaryKey;
        if (!candidateUpdates || candidateUpdates.length === 0) {
          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: (
              <FormattedMessage id="snackbar.noRecordsToSave" defaultMessage="No edited records selected to save." />
            ),
            severity: "warning"
          });
        } else {
          // Ensure the grid commits any active row edits for these ids so validations run
          const ids = candidateUpdates.map(u => String(u.custValId || u.id || u.custValId));
          try {
            if (apiRef?.current?.stopRowEditMode) {
              ids.forEach(id => {
                try {
                  apiRef.current.stopRowEditMode({ id: isNaN(id) ? id : Number(id) });
                } catch (e) {}
              });
            }
          } catch (e) {}

          // Wait shortly for the grid to process edit commits, then rebuild payload from the grid state
          setTimeout(() => {
            try {
              const editModel = apiRef.current?.getEditRowsModel?.();
              // Prevent saving when there are validation errors for these ids
              if (hasValidationErrorsForIds(ids)) {
                setAlertBoxState({
                  ...alertBoxState,
                  openAlert: true,
                  message: (
                    <FormattedMessage id="custom.warning.fixValidation" defaultMessage="Please fix validation errors before saving." />
                  ),
                  severity: "warning"
                });
                return;
              }

              const finalUpdates = ids.map(id => {
                const current = apiRef.current?.getRow?.(id) || tableData.find(r => String(r.custValId) === String(id)) || {};
                if (editModel && editModel[id]) {
                  const pending = { ...current };
                  Object.keys(editModel[id]).forEach(field => {
                    const cell = editModel[id][field];
                    pending[field] = cell && cell.value !== undefined ? cell.value : cell;
                  });
                  return { ...current, ...pending };
                }
                return { ...current };
              });

              CommonService.saveOrUpdateOrPost("/UpdateCustomsValuation", finalUpdates)
                .then(response => {
                  setAlertBoxState({
                    ...alertBoxState,
                    openAlert: true,
                    message: (
                      <FormattedMessage id="snackbar.savedSuccessfully" defaultMessage="Record Saved successfully" />
                    ),
                    severity: "success"
                  });

                  // remove saved ids from editedRowsMap
                  const savedIds = ids.map(i => String(i));
                  setEditedRowsMap(prev => {
                    const copy = { ...prev };
                    Object.keys(copy).forEach(key => {
                      if (savedIds.includes(String(key))) delete copy[key];
                    });
                    return copy;
                  });

                  // remove validation errors for saved rows
                  setValidationErrors(prev => {
                    if (!prev) return {};
                    const copy = { ...prev };
                    Object.keys(copy).forEach(k => {
                      const [id] = k.split("__");
                      if (savedIds.includes(String(id))) delete copy[k];
                    });
                    return copy;
                  });

                  // Ensure row edit mode is stopped and editingRowIds cleared for saved ids
                  try {
                    if (apiRef?.current?.stopRowEditMode) {
                      savedIds.forEach(id => {
                        try {
                          apiRef.current.stopRowEditMode({ id: isNaN(id) ? id : Number(id) });
                        } catch (e) {}
                      });
                    }
                  } catch (e) {}

                  setEditingRowIds(prev => prev.filter(id => !savedIds.includes(String(id))));
                  setSelectedRow([]);
                  setRefreshTable(prev => !prev);
                  setIsEditMode(false);
                })
                .catch(error => {
                  const message = error?.response?.data?.message || "Failed to save edited records.";
                  setAlertBoxState({
                    ...alertBoxState,
                    openAlert: true,
                    message,
                    severity: "error"
                  });
                });
            } catch (err) {
              setAlertBoxState({
                ...alertBoxState,
                openAlert: true,
                message: "Error collecting committed edits from grid.",
                severity: "error"
              });
            }
          }, 150);
        }
      } else {
        const baseApi = apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen.customsValuation.replace(/\/$/, "");

        // If bulkDeleteMode is true, primaryKey is an array of ids
        if (bulkDeleteMode && Array.isArray(primaryKey)) {
          const batchApi = `${baseApi}/delete`;
          // Send only the array of ids as request body (server expects List<Integer> in @RequestBody)
          CommonService.saveOrUpdateOrPost(batchApi, primaryKey)
            .then(response => {
              setAlertBoxState({
                ...alertBoxState,
                openAlert: true,
                message: (
                  <FormattedMessage
                    id="snackbar.recorddeletedsuccessfully"
                    defaultMessage="Records deleted successfully"
                  />
                ),
                severity: "success"
              });
              setSelectedRow([]);
              setBulkDeleteMode(false);
              setRefreshTable(prev => !prev);
              // no-op: previously ran pending action for unsavedAction (now we only warn)
            })
            .catch(error => {
              const message =
                error?.response?.data?.message || "Error occurred while deleting records!";
              setAlertBoxState({
                ...alertBoxState,
                openAlert: true,
                message,
                severity: "error"
              });
              setBulkDeleteMode(false);
            });
        } else {
          CommonService.deleteByIdApi(`${baseApi}/${primaryKey}`, {})
            .then(response => {
              setAlertBoxState({
                ...alertBoxState,
                openAlert: true,
                message: (
                  <FormattedMessage
                    id="snackbar.recorddeletedsuccessfully"
                    defaultMessage="Record Deleted successfully"
                  />
                ),
                severity: "success"
              });
              setRefreshTable(prev => !prev);
            })
            .catch(error => {
              const message =
                error?.response?.data?.message || "Error occurred while deleting!";
              setAlertBoxState({
                ...alertBoxState,
                openAlert: true,
                message,
                severity: "error"
              });
            });
        }
      }
    }
  };

  useEffect(() => {
    if (intialParamBodyApiCall) {
      if (skipNextFilterEffect) {
        setSkipNextFilterEffect(false);
        return;
      }
      console.log("selectedFilters", selectedFilters);
      const activeFilters = selectedFilters.filter(
        filter =>
          filter.value !== null &&
          filter.value !== undefined &&
          filter.value !== ""
      );
      setFilterCount(activeFilters.length);
      applyFilter();
    }
  }, [intialParamBodyApiCall, selectedFilters]);

  useEffect(() => {
    setIntialParamBodyApiCall(false);
    setTableLoadingStatus(true);
    manageUserPreferences
      .loadUserPreferences({
        body: {
          screenName: componentList[1].name.props.id,
          tabName: componentList[1].name.props.id,
          userId: 0,
          organization: {},
          entity: {}
        }
      })
      .then(response => {
        if (response.data === null) {
          // No saved preferences for this user — use defaults in-memory
          // but do NOT persist defaults automatically (avoids duplicate-key errors).
          setColumns(commonColumnForCustomsValuation);
          // We intentionally do NOT call savePreference here. Saving should
          // only happen when the user changes preferences.
        }
        //preference present in db
        else {
          var savedColumnsInResponse = JSON.parse(response.data.preferences);
          var orderedColumns = orderAndHideColumns(
            savedColumnsInResponse.columnsOrdervisible,
            commonColumnForCustomsValuation
          );
          setPinnedColumns(savedColumnsInResponse.columnsPinned);
          setColumns(orderedColumns);

          let entity = null;
          let judge = null;
          let msgStatusFlag = null;
          let declareCls = null;
          let firstImportDate = null;
          let pic = null;
          let makerPartNo = null;
          let createdMonthFrom = null;
          let createdMonthTo = null;
          let firstImportFrom = null;
          let firstImportTo = null;
          let importDeclarationFrom = null;
          let importDeclarationTo = null;

          savedColumnsInResponse.columnsFilter.map(columns => {
            switch (columns.columnField) {
              case "entity.erpEntityCode":
                entity = columns.value;
                break;
              case "msgStatusFlag":
                msgStatusFlag = columns.value;
                break;
              case "judge":
                judge = columns.value;
                break;
              case "declareCls":
                declareCls = columns.value;
                break;
              case "firstImportDate":
                firstImportDate = columns.value;
                break;
              case "pic":
                pic = columns.value;
                break;
              case "makerPartNo":
                makerPartNo = columns.value;
                break;
              case "createdMonthFrom":
                createdMonthFrom = columns.value;
                break;
              case "createdMonthTo":
                createdMonthTo = columns.value;
                break;
              case "importDeclarationFrom":
                importDeclarationFrom = columns.value;
                break;
              case "importDeclarationTo":
                importDeclarationTo = columns.value;
                break;
              case "firstImportFrom":
                firstImportFrom = columns.value;
                break;
              case "firstImportTo":
                firstImportTo = columns.value;
                break;
            }
          });

          setSearchedErpEntityCode(entity);
          setSearchedJudge(judge);
          setSearchMsgStatus(msgStatusFlag);
          setSearchedDeclareCls(declareCls);
          setSearchedFirstImportFrom(firstImportFrom);
          setSearchedFirstImportTo(firstImportTo);
          setSearchedImportDeclarationFrom(importDeclarationFrom);
          setSearchedImportDeclarationTo(importDeclarationTo);
          setSearchedCreatedFrom(createdMonthFrom);
          setSearchedCreatedTo(createdMonthTo);
          setSearchedPic(pic);
          setSearchedMakerPartNo(makerPartNo);

          // Only set selectedFilters; the filters effect will call applyFilter()
          // which will update paramBody. This prevents duplicate API calls.
          if (savedColumnsInResponse.columnsFilter.length > 0) {
            console.log(savedColumnsInResponse.columnsFilter.length);
            setSkipNextFilterEffect(true);
            // filter out any invalid saved filters that don't have a columnField
            const validSavedFilters = savedColumnsInResponse.columnsFilter.filter(
              f => f && f.columnField
            );
            setSelectedFilters(validSavedFilters);
            // Build paramBody immediately from saved filters to avoid effect running applyFilter
            setParamBody(prevState => {
              const filterBody = {
             
              };
              validSavedFilters.forEach(col => {
                // defensive: skip entries without a columnField
                if (!col || !col.columnField) return;

                if (col.columnField === "entity.erpEntityCode") {
                  filterBody.entity.erpEntityCode = col.value;
                } else if (col.columnField === "orgCode") {
                  filterBody.organization = { erpOrgCode: col.value };
                } else if (col.columnField === "confirmationStatus") {
                  // backend expects integer codes for confirmationStatus
                  if (col.value === "Not-Confirmed") filterBody.confirmationStatus = 0;
                  else if (col.value === "Confirmed") filterBody.confirmationStatus = 1;
                  else if (typeof col.value === "string" && /^\d+$/.test(col.value))
                    filterBody.confirmationStatus = parseInt(col.value, 10);
                  else filterBody.confirmationStatus = col.value;
                } else {
                  filterBody[col.columnField] = col.value;
                }
              });
              return {
                ...prevState,
                body: filterBody,
                sortDir: savedColumnsInResponse.columnsSort.sort,
                sortKey: savedColumnsInResponse.columnsSort.field
              };
            });
          } else {
            // No saved filters; set default paramBody and trigger initial fetch
            var filterBody = {
               
            };
            paramBody.body = filterBody;
            paramBody.sortDir = savedColumnsInResponse.columnsSort.sort;
            paramBody.sortKey = savedColumnsInResponse.columnsSort.field;
            setParamBody({ ...paramBody });
          }
        }
        // All initial paramBody/selectedFilters setup done — enable API fetching
        setIntialParamBodyApiCall(true);
      })
      .catch(function(error) {
        setTableLoadingStatus(false);
        setIntialParamBodyApiCall(true);
        if (error.response !== undefined) {
          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: error.response.data.message,
            severity: "error"
          });
        }
      });
  }, [selectedLanguage, componentMountTrigger]);

  useEffect(() => {
    if (intialParamBodyApiCall) {
      setTableLoadingStatus(true);
      setTableData([]);
      CommonService.GetListApi(
        apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen
          .customsValuation,
        paramBody
      )
        .then(response => {
          setTotalRowCount(response.data.totalElements);
          setTableLoadingStatus(false);
          setTableData(response.data.content);

          // Extract role access from response
          const roleSubModuleAccess =
            response.data.content?.[0]?.roleSubModuleAccess || [];

          // Only update role access if it hasn't been loaded yet
          if (!roleAccessLoaded && roleSubModuleAccess.length > 0) {
            setRoleSubModuleAccess(roleSubModuleAccess);
            setRoleAccessLoaded(true);
          }

          response.data.totalElements > 0
            ? setChipInfoList(
                response.data.content[0].headerChipList === null
                  ? []
                  : response.data.content[0].headerChipList
              )
            : setChipInfoList([]);
        })
        .catch(function(error) {
          setTableLoadingStatus(false);
          if (error.response !== undefined) {
            setAlertBoxState({
              ...alertBoxState,
              openAlert: true,
              message: error.response.data.message,
              severity: "error"
            });
          }
        });
    }
  }, [paramBody, refreshTable]);

  useEffect(() => {
    if (totalRowCount === 0) {
      setDisiablingDownloadButtonForZeroRecords(true);
    } else {
      setDisiablingDownloadButtonForZeroRecords(false);
    }
  }, [totalRowCount]);

  useEffect(() => {
    if (msgHdrPopUp === true) {
      setOpenBackDrop(true);
      CommonService.saveOrUpdateOrPost("/reports/CUSTOMS_VALUATION_REPORT", {
        entityCode: "SO"
      })
        .then(response => {
          if (response.data.sucess === "No records found for given condition")
            setAlertBoxState({
              ...alertBoxState,
              openAlert: true,
              message: response.data.sucess,
              severity: "error"
            });
          else {
            setAlertBoxState({
              ...alertBoxState,
              openAlert: true,
              message: (
                <FormattedMessage
                  id="yourrequestno.snackbar.text"
                  values={{
                    responsedata: `${response.data.value}`,
                    reportName: `${response.data.reportName}`
                  }}
                />
              ),
              severity: "success"
            });
          }
          setOpenBackDrop(false);
        })
        .catch(function(error) {
          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message:
              error.response === undefined
                ? "Error occured"
                : error.response.message,
            severity: "error"
          });
          setOpenBackDrop(false);
        });
      setMsgHdrPopUp(false);
    }
  }, [msgHdrPopUp, keyValueData]);

  if (columns.length > 0) {
    const orgNameColumn = columns.find(
      column => column.field === columnFieldsName.orgName
    );
    const orgNameColIndex = columns.findIndex(
      col => col.field === columnFieldsName.orgName
    );

    const orgNameFilterOperators = getGridStringOperators().map(operator => ({
      ...operator,
      InputComponent: CustomFilters.OrgNameInputValue
    }));

    columns[orgNameColIndex] = {
      ...orgNameColumn,
      filterOperators: orgNameFilterOperators
    };

    const entityCodeColumn = columns.find(
      column => column.field === columnFieldsName.entity
    );
    const entityCodeColIndex = columns.findIndex(
      col => col.field === columnFieldsName.entity
    );

    const entityCodeFilterOperators = getGridStringOperators().map(
      operator => ({
        ...operator,
        InputComponent: CustomFilters.EntityCodeInputValue
      })
    );

    columns[entityCodeColIndex] = {
      ...entityCodeColumn,
      filterOperators: entityCodeFilterOperators
    };

    const statusFlagColumn = columns.find(
      column => column.field === columnFieldsName.msgStatusFlag
    );
    const statusFlagColIndex = columns.findIndex(
      col => col.field === columnFieldsName.msgStatusFlag
    );

    const statusFlagFilterOperators = getGridStringOperators().map(
      operator => ({
        ...operator,
        InputComponent: CustomFilters.InvoiceeMsgStatusValue
      })
    );

    columns[statusFlagColIndex] = {
      ...statusFlagColumn,
      filterOperators: statusFlagFilterOperators
    };

    const makerPartNoColumn = columns.find(
      column => column.field === columnFieldsName.makerPartNo
    );
    const makerPartNoColIndex = columns.findIndex(
      col => col.field === columnFieldsName.makerPartNo
    );

    if (makerPartNoColumn && makerPartNoColIndex !== -1) {
      const makerPartNoFilterOperators = getGridStringOperators().map(
        operator => ({
          ...operator,
          InputComponent: CustomFilters.MakerPartNoInputValue // or use a generic text input
        })
      );

      columns[makerPartNoColIndex] = {
        ...makerPartNoColumn,
        filterOperators: makerPartNoFilterOperators
      };
    }
  }

  const getDataBasedOnTheSelectedField = tableData.map(row => {
    return {
      entityCode: row.entity.erpEntityCode
    };
  });

  const filterValueLoad = getDataBasedOnTheSelectedField.filter(item => {
    if (selectedRow.includes(item.msgId)) {
      return item;
    }
  });

  const entittyCodeValue = filterValueLoad.map(row => {
    return row.entityCode;
  });
  const filterValueApproved = filterValueLoad.map(row => {});

  const onSubmitApprovals = () => {
    setIsFormSubmitted(true);
    setIsRowSentForApproval(true);
    setOpenBackDrop(true);

    // const filterValueConfirmed = Array.isArray(selectedRowsData)
    // ? selectedRowsData.map(row => row.confirmed)
    // : [];

    // if (filterValueConfirmed.includes(1)) {
    //   const userConfirmed = window.confirm(
    //     "Selected records already contain Approved entries. Do you still want to proceed and update the status?"
    //   );

    //   if (!userConfirmed) {
    //     setIsRowSentForApproval(false);
    //     setIsFormSubmitted(false);
    //     setOpenBackDrop(false);
    //     return; // stop further execution
    //   }

    //   const msgIds = Array.isArray(selectedRowsData)
    //   ? selectedRowsData.map(row => row.custValId)
    //   : [selectedRowsData.custValId];

    // CommonService.saveOrUpdateOrPost("/verifyCustomsValuationData", msgIds)
    //   .then(response => {
    //     setIsFormSubmitted(false);
    //     setIsRowSentForApproval(false);
    //     setAlertBoxState({
    //       ...alertBoxState,
    //       openAlert: true,
    //       message: `MsgId : ${selectedRowsData.custValId} has been approved successfully`,
    //       severity: "success"
    //     });
    //     setSelectedRow([]);
    //     setRefreshTable(!refreshTable);
    //     isDisableApproveButton(true);
    //     isDisableRejectionButton(true);
    //     setOpenBackDrop(false);
    //   })
    //   .catch(function(error) {
    //     setIsFormSubmitted(false);
    //     setAlertBoxState({
    //       ...alertBoxState,
    //       openAlert: true,
    //       message: error.response.message,
    //       severity: "error"
    //     });
    //     isDisableApproveButton(false);
    //     setOpenBackDrop(false);
    //   });

    // } else {
    const custValIds = Array.isArray(selectedRowsData)
      ? selectedRowsData.map(row => row.custValId)
      : [selectedRowsData.custValId];

    setIsEditMode(false);

    CommonService.saveOrUpdateOrPost("/verifyCustomsValuationData", custValIds)
      .then(response => {
        setIsFormSubmitted(false);
        setIsRowSentForApproval(false);
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: `Record has been Updated successfully`,
          severity: "success"
        });
        setSelectedRow([]);
        setRefreshTable(!refreshTable);
        isDisableApproveButton(true);
        isDisableRejectionButton(true);
        setOpenBackDrop(false);
      })
      .catch(function(error) {
        setIsFormSubmitted(false);
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: error.response.message,
          severity: "error"
        });
        isDisableApproveButton(false);
        setOpenBackDrop(false);
      });
    //}
  };

  useEffect(() => {
    if (selectedRow.length === 0) {
      isDisableApproveButton(true);
      isDisableRejectionButton(true);
    } else if (filterValueApproved.toString().includes("0")) {
      isDisableApproveButton(false);
      isDisableRejectionButton(false);
    } else if (filterValueApproved.toString().includes("1")) {
      isDisableApproveButton(true);
      isDisableRejectionButton(true);
    } else if (filterValueApproved.toString().includes("2")) {
      isDisableApproveButton(false);
      isDisableRejectionButton(true);
    } else {
      isDisableApproveButton(false);
      isDisableRejectionButton(false);
    }
  }, [filterValueApproved]);

  useEffect(() => {
    if (roleAccessLoaded && roleSubModuleAccess.length > 0) {
      // Log permissions
      roleSubModuleAccess.forEach(perm => {
        console.log(`- ${perm.subModule?.description}: ${perm.accessFlag}`);
      });

      // Force DataGrid to re-render with updated columns
      // This ensures the action column re-evaluates with correct permissions
      setColumns(prevColumns => {
        // If we have preferences applied, preserve the hide/order settings
        if (prevColumns.length > 0) {
          return prevColumns.map(col => {
            const freshCol = commonColumnForCustomsValuation.find(
              c => c.field === col.field
            );
            if (freshCol) {
              return {
                ...freshCol,
                hide: col.hide // preserve visibility preference
              };
            }
            return col;
          });
        }
        return commonColumnForCustomsValuation;
      });
    }
  }, [roleAccessLoaded, roleSubModuleAccess, commonColumnForCustomsValuation]);

  const filterableColumns = useMemo(() => GetFilterableColumns(columns), [
    columns
  ]);
  const key = "columnField";
  const applyFilter = () => {
    let entity = null;
    let orgCode = null;
    let judge = null;
    let msgStatusFlag = null;
    let declareCls = null;
    let firstImportDate = null;
    let makerPartNo = null;

    let makerPartNo2 = null;
    let makerPartNo3 = null;
    let keywordOneCheck = null;
    let keywordTwoCheck = null;
    let createdMonthFrom = null;
    let createdMonthTo = null;
    let firstImportFrom = null;
    let firstImportTo = null;
    let pic = null;
    let importDeclarationFrom = null;
    let importDeclarationTo = null;
    let importDeclarationNo = null;
    let reasonForNoDeclareCls = null;
    let remarks = null;
    let invoiceNo = null;
    let soNo = null;
    let itemCode = null;
    let project = null;
    let confirmationStatus = null;
    let section = null;
    let shipNoSoNo = null;
    selectedFilters.map(columns => {
      switch (columns.columnField) {
        case "entity":
          entity = columns.value;
          break;
        case "orgCode":
          orgCode = columns.value;
          break;
        case "msgStatusFlag":
          msgStatusFlag = columns.value;
          break;
        case "judge":
          judge = columns.value;
          break;
        case "declareCls":
          declareCls = columns.value;
          break;
        case "firstImportDate":
          firstImportDate = columns.value;
          break;
        case "makerPartNo":
          makerPartNo = columns.value;
          break;

        case "makerPartNo2":
          makerPartNo2 = columns.value;
          break;
        case "makerPartNo3":
          makerPartNo3 = columns.value;
          break;
        case "keywordOneCheck":
          keywordOneCheck = columns.value;
          break;
        case "keywordTwoCheck":
          keywordTwoCheck = columns.value;
          break;

        case "createdMonthFrom":
          createdMonthFrom = columns.value;
          break;
        case "pic":
          pic = columns.value;
          break;
        case "createdMonthTo":
          createdMonthTo = columns.value;
          break;
        case "importDeclarationFrom":
          importDeclarationFrom = columns.value;
          break;
        case "importDeclarationTo":
          importDeclarationTo = columns.value;
          break;
        case "firstImportFrom":
          firstImportFrom = columns.value;
          break;
        case "firstImportTo":
          firstImportTo = columns.value;
          break;
        case "reasonForNoDeclareCls":
          reasonForNoDeclareCls = columns.value;
          break;
        case "remarks":
          remarks = columns.value;
          break;
        case "invoiceNo":
          invoiceNo = columns.value;
          break;
        case "soNo":
          soNo = columns.value;
          break;
        case "itemCode":
          itemCode = columns.value;
          break;
        case "project":
          project = columns.value;
          break;
        case "confirmationStatus":
          confirmationStatus = columns.value;
          break;
        case "importDeclarationNo":
          importDeclarationNo = columns.value;
          break;
        case "section":
          section = columns.value;
          break;
        case "shipNoSoNo":
          shipNoSoNo = columns.value;
          break;
      }
    });

    setSearchedErpEntityCode(entity);
    setSearchedJudge(judge);
    setSearchMsgStatus(msgStatusFlag);
    setSearchedDeclareCls(declareCls);
    setSearchedFirstImportFrom(firstImportFrom);
    setSearchedFirstImportTo(firstImportTo);
    setSearchedImportDeclarationFrom(importDeclarationFrom);
    setSearchedImportDeclarationTo(importDeclarationTo);
    setSearchedCreatedFrom(createdMonthFrom);
    setSearchedCreatedTo(createdMonthTo);
    setSearchedPic(pic);
    setSearchedMakerPartNo(makerPartNo);
    setSearchedOrgCode(orgCode);
    setSearchedReasonForNotReq(reasonForNoDeclareCls);
    setSearchedRemarks(remarks);
    setSearchedInvoiceNo(invoiceNo);
    setSearchedSoNo(soNo);
    setSearchedItemCode(itemCode);
    setSearchedProject(project);
    setSearchedConfirmationStatus(confirmationStatus);
    setSearchedImportDeclarationNo(importDeclarationNo);
    setSearchedSection(section);
    savePreference(
      "filter",
      selectedFilters.length === 0 ? defaulSelectedFilters : selectedFilters
    );
    setParamBody(prevState => {
      const filterBody = {
     
      };

      if (judge !== null && judge !== undefined && String(judge).trim() !== "")
        filterBody.judge = judge;
      if (
        declareCls !== null &&
        declareCls !== undefined &&
        String(declareCls).trim() !== ""
      )
        filterBody.declareCls = declareCls;
      if (
        firstImportFrom !== null &&
        firstImportFrom !== undefined &&
        String(firstImportFrom).trim() !== ""
      )
        filterBody.firstImportFrom = firstImportFrom;
      if (
        firstImportTo !== null &&
        firstImportTo !== undefined &&
        String(firstImportTo).trim() !== ""
      )
        filterBody.firstImportTo = firstImportTo;
      if (
        importDeclarationFrom !== null &&
        importDeclarationFrom !== undefined &&
        String(importDeclarationFrom).trim() !== ""
      )
        filterBody.importDeclarationFrom = importDeclarationFrom;
      if (
        importDeclarationTo !== null &&
        importDeclarationTo !== undefined &&
        String(importDeclarationTo).trim() !== ""
      )
        filterBody.importDeclarationTo = importDeclarationTo;
      if (
        importDeclarationNo !== null &&
        importDeclarationNo !== undefined &&
        String(importDeclarationNo).trim() !== ""
      )
        filterBody.importDeclarationNo = importDeclarationNo;
      if (
        createdMonthFrom !== null &&
        createdMonthFrom !== undefined &&
        String(createdMonthFrom).trim() !== ""
      )
        filterBody.createdMonthFrom = createdMonthFrom;
      if (
        createdMonthTo !== null &&
        createdMonthTo !== undefined &&
        String(createdMonthTo).trim() !== ""
      )
        filterBody.createdMonthTo = createdMonthTo;
      if (pic !== null && pic !== undefined && String(pic).trim() !== "")
        filterBody.pic = pic;
      if (
        makerPartNo !== null &&
        makerPartNo !== undefined &&
        String(makerPartNo).trim() !== ""
      )
        filterBody.makerPartNo = makerPartNo;

      if (
        makerPartNo2 !== null &&
        makerPartNo2 !== undefined &&
        String(makerPartNo2).trim() !== ""
      )
        filterBody.makerPartNo2 = makerPartNo2;
      if (
        makerPartNo3 !== null &&
        makerPartNo3 !== undefined &&
        String(makerPartNo3).trim() !== ""
      )
        filterBody.makerPartNo3 = makerPartNo3;
      if (keywordOneCheck !== null && keywordOneCheck !== undefined)
        filterBody.keywordOneCheck = keywordOneCheck;
      if (keywordTwoCheck !== null && keywordTwoCheck !== undefined)
        filterBody.keywordTwoCheck = keywordTwoCheck;

      if (
        reasonForNoDeclareCls !== null &&
        reasonForNoDeclareCls !== undefined &&
        String(reasonForNoDeclareCls).trim() !== ""
      )
        filterBody.reasonForNoDeclareCls = reasonForNoDeclareCls;
      if (
        remarks !== null &&
        remarks !== undefined &&
        String(remarks).trim() !== ""
      )
        filterBody.remarks = remarks;
      if (
        invoiceNo !== null &&
        invoiceNo !== undefined &&
        String(invoiceNo).trim() !== ""
      )
        filterBody.invoiceNo = invoiceNo;
      if (soNo !== null && soNo !== undefined && String(soNo).trim() !== "")
        filterBody.soNo = soNo;
      if (shipNoSoNo !== null && shipNoSoNo !== undefined && String(shipNoSoNo).trim() !== "")
        filterBody.shipNoSoNo = shipNoSoNo;
      if (
        itemCode !== null &&
        itemCode !== undefined &&
        String(itemCode).trim() !== ""
      )
        filterBody.itemCode = itemCode;
      if (
        project !== null &&
        project !== undefined &&
        String(project).trim() !== ""
      )
        filterBody.project = project;
      if (
        section !== null &&
        section !== undefined &&
        String(section).trim() !== ""
      )
        filterBody.section = section;

      if (confirmationStatus === "Not-Confirmed") {
        filterBody.confirmationStatus = 0;
      } else if (confirmationStatus === "Confirmed") {
        filterBody.confirmationStatus = 1;
      } else if (
        confirmationStatus !== null &&
        confirmationStatus !== undefined &&
        String(confirmationStatus).trim() !== ""
      ) {
        filterBody.confirmationStatus = confirmationStatus;
      }

      return {
        ...prevState,
        body: filterBody
      };
    });
  };

  // useEffect(() => {
  //     if (intialParamBodyApiCall)
  //         setFilterCount([...new Map(selectedFilters.map(item => [item[key], item])).values()].length)
  // }, [selectedFilters, tableData])

  let filterBodyObj = {
    entityCode: searchedErpEntityCode === null ? "" : searchedErpEntityCode,
    judge: searchedJudge === null ? "" : searchedJudge,
    makerPartNo: searchedMakerPartNo === null ? "" : searchedMakerPartNo,
    msgStatusFlag:
      searchedMsgStatus === "Not Sent"
        ? 0
        : searchedMsgStatus === "Pending"
        ? 1
        : searchedMsgStatus === "Successfully Sent"
        ? 2
        : searchedMsgStatus === "Failed to Send"
        ? 3
        : searchedMsgStatus === "Cancelled"
        ? 4
        : null
  };

  useEffect(() => {
    let colValDataObj = {};
    for (let key in filterBodyObj) {
      let value = filterBodyObj[key];
      if (
        filterBodyObj.hasOwnProperty(key) &&
        (value !== null && value !== undefined && value !== {})
      ) {
        colValDataObj[key] = value.toString();
      }
      setKeyValueData(colValDataObj);
    }
  }, [
    searchedErpEntityCode,
    searchedBpType,
    searchedInvoiceNo,
    searchedBuyerPartyCode,
    searchedBuyerName,
    searchedSupplierPartyCode,
    searchedSupplierName,
    searchedMsgStatus,
    searchedCommType,
    searchedMakerPartNo
  ]);
  const closeFileUploadSection = confirmed => {
    setopenFileUploadSection(false);
  };
  const {
    open,
    onClose,
    defaultBpType,
    dialogHeader,
    showToggleButton,
    isPartchange,
    refreshAddOrView,
    setRefreshAddOrView
  } = props;

  function formatDateTimeLocal(dateStr) {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const pad = n => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  }

  const ReasonDropdownEditCell = ({ id, field, value, api, disabled, row }) => {
    // Enable only when declareCls is exactly "不要"; consider in-progress edits
    let declareValue = row?.declareCls;
    try {
      const editModel = api.getEditRowsModel && api.getEditRowsModel();
      const pending = editModel && editModel[id] && editModel[id].declareCls && editModel[id].declareCls.value;
      if (pending !== undefined && pending !== null) declareValue = pending;
    } catch (e) {}

    const isDisabledByDeclareCls = declareValue !== "00";
    const isFullyDisabled = Boolean(disabled) || isDisabledByDeclareCls;

    const handleChange = event => {
      if (isFullyDisabled) return;
      api.setEditCellValue({
        id,
        field,
        value: event.target.value
      });
    };

    return (
      <select
        value={isFullyDisabled ? "" : value || ""}
        onChange={handleChange}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          outline: "none",
          padding: "8px",
          pointerEvents: isFullyDisabled ? "none" : "auto",
          backgroundColor: isFullyDisabled ? "#f3f3f3" : "white",
          color: isFullyDisabled ? "#777" : "black",
          cursor: isFullyDisabled ? "not-allowed" : "pointer"
        }}
        disabled={isFullyDisabled}
        tabIndex={isFullyDisabled ? -1 : 0}
      >
        <option value="" disabled>
          Select reason
        </option>
        {reasonOptions.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  };

  const DeclareClsDropDown = ({ id, field, value, api, disabled }) => {
    const handleChange = event => {
      if (disabled) return;

      const newValue = event.target.value;

      // Set the declareCls value
      api.setEditCellValue({
        id,
        field,
        value: newValue
      });

      // If declareCls is changed to "要", clear the reasonForNoDeclareCls field
          // If declareCls is changed away from "不要" then clear the reason
          if (newValue !== "00") {
            try {
              api.setEditCellValue({
                id,
                field: "reasonForNoDeclareCls",
                value: null
              });
            } catch (e) {}
          }
    };

    return (
      <select
        value={value || ""}
        onChange={handleChange}
        style={{
          width: "100%",
          height: "100%",
          pointerEvents: disabled ? "none" : "auto",
          backgroundColor: disabled ? "#f3f3f3" : "white",
          color: disabled ? "#777" : "black"
        }}
        disabled={disabled}
        tabIndex={disabled ? -1 : 0}
      >
        <option value="" disabled>
          Select DeclareCls
        </option>
        {declareOptions.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={openAlert}
        onClose={handleCloseAlert}
        key={vertical + horizontal}
        autoHideDuration={6000}
      >
        <Alert
          onClose={handleCloseAlert}
          severity={
            ["success", "info", "warning", "error"].includes(severity)
              ? severity
              : "info"
          }
        >
          {message}
        </Alert>
      </Snackbar>

      <FileUploadSection
        open={openFileUploadSection}
        onClose={closeFileUploadSection}
        defaultEntity={defaultEntity}
        defaultBpType={"SUPPLIER"}
        dialogHeader={
          <FormattedMessage
            id="common.button.uploadfiles.tooltip"
            defaultMessage="Upload files"
          />
        }
        showToggleButton={false}
        selectedRow={selectedRow}
        isPartchange={isPartchange}
        refreshAddOrView={refreshTable}
        setRefreshAddOrView={setRefreshTable}
      />
      <CustomsValuationFilterDialog
        open={openFilterDialog}
        onClose={() => setOpenFilterDialog(false)}
        handleSearch={formData => {
          const mappedParamBody = {
            body: {
              declareCls: formData.declareCls,
              judge: formData.judge,
              firstImportFrom: formData.firstImportFrom,
              firstImportTo: formData.firstImportTo,
              importDeclarationNo: formData.importDeclarationNo,
              importDeclarationFrom: formData.importDeclarationFrom,
              importDeclarationTo: formData.importDeclarationTo,
              createdMonthFrom: formData.createdMonthFrom,
              createdMonthTo: formData.createdMonthTo,
              pic: formData.pic,
              section: formData.section,
              makerPartNo: formData.makerPartNo,
              makerPartNo2: formData.makerPartNo2,
              makerPartNo3: formData.makerPartNo3,
              keywordOneCheck: formData.keywordOneCheck,
              keywordTwoCheck: formData.keywordTwoCheck,
              shipNoSoNo: formData.shipNoSoNo

              // entity: defaultEntity
            },
            pageNo: 0,
            sortDir: "desc",
            sortKey: "createdTime",
            recordsPerPage: 25
          };

          // formData.entity = defaultEntity;
          const filterCount = Object.entries(formData).filter(
            ([key, value]) =>
              value !== undefined &&
              value !== null &&
              String(value).trim() !== ""
            // key !== "entity" // Optional: exclude fixed or default values
          ).length;

          setFilterCount(filterCount);

          const filtersToSave = Object.entries(formData)
            .filter(
              ([key, value]) =>
                value !== undefined &&
                value !== null &&
                String(value).trim() !== ""
            )
            .map(([key, value], index) => ({
              id: index,
              columnField: key,
              headerName: key,
              operatorValue: [
                "makerPartNo",
                "makerPartNo2",
                "makerPartNo3",
                "itemCode",
                "soNo",
                "invoiceNo",
                "project",
                "section",
                "shipNoSoNo"
              ].includes(key)
                ? "equals"
                : "contains",
              value: value
            }));

          // Update selectedFilters; applyFilter effect will run once and call setParamBody
          setSelectedFilters(filtersToSave);
          savePreference("filter", filtersToSave);
          setIsEditMode(false);
        }}
        initialFilters={selectedFilters}
      />
      <CommonBackDrop open={openBackDrop} />
      <Grid container className={classes.rootForRole}>
        <Grid
          item
          container
          justifyContent="flex-start"
          alignItems="center"
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className={classes.topGrid}
          style={{ marginLeft: "-0.5%" }}
        >
          <CustomBreadCrumb componentList={componentList} />
        </Grid>
        <CustomFilterComponent
          open={openFilterPanel}
          onClose={handleClose}
          filterableColumns={filterableColumns}
          setSelectedFilters={setSelectedFilters}
          selectedFilters={selectedFilters}
          applyFilter={applyFilter}
          defaulSelectedFilters={defaulSelectedFilters}
        />
        <ChipInfoList chipInfoList={chipInfoList} />
        <Paper
          elevation={3}
          style={{ marginTop: "5px" }}
          className={classes.gridHeightAndWidthForASN}
        >
          <div style={{ height: "100%", width: "100%" }}>
            {/* style for highlighting edited rows and validation-error rows */}
            <style>{`.edited-row{background-color:#E3F2FD !important;} .edited-row .MuiDataGrid-cell{background-color:transparent !important;} .validation-error-row{background-color:#FFCDD2 !important;} .validation-error-row .MuiDataGrid-cell{background-color:transparent !important;}`}</style>
            <DataGridPro
              key={gridKey}
              className={classes.customTableStyle}
              sortingMode="server"
              rows={tableData}
              columns={columnsWithHeaderErrors}
              showToolbar
              pageSize={paramBody.recordsPerPage}
              page={paramBody.pageNo}
              loading={tableLoadingStatus}
              rowCount={totalRowCount}
              getRowId={row => row.custValId}
              scrollbarSize={30}
              disableColumnFilter={true}
              rowsPerPageOptions={[1, 2, 10, 25, 50, 100]}
              pagination
              density="compact"
              paginationMode="server"
              disableSelectionOnClick={true}
              disableMultipleColumnsSorting={true}
              isRowSelectable={params => true}
              hideFooter={true}
              checkboxSelection={true}
              onSelectionModelChange={currentlySelectedRow}
              selectionModel={selectedRow}
              localeText={localtext}
              apiRef={apiRef}
              getRowClassName={params => {
                try {
                  if (hasValidationErrorsForIds([params.id])) return "validation-error-row";
                } catch (e) {}
                return isRowEdited(params.id) ? "edited-row" : "";
              }}
              onRowClick={params => {
                try {
                  // Only allow single-click to enter edit mode when Edit toolbar is active
                  if (!isEditMode) return;

                  const id = params.id;
                  const idStr = String(id);

                  const editIdsStr = (editingRowIds || []).map(String);
                  const selectedIdsStr = (selectedRow || []).map(String);
                  const inEditedMap = editedRowsMap && Object.prototype.hasOwnProperty.call(editedRowsMap, idStr);

                  // Consider row eligible for single-click edit if it's part of the edit set,
                  // currently selected, or has pending edited data in editedRowsMap
                  const eligible = editIdsStr.includes(idStr) || selectedIdsStr.includes(idStr) || inEditedMap;
                  if (!eligible) return;

                  // Ensure editingRowIds includes this id so isCellEditable returns true
                  setEditingRowIds(prev => {
                    const arr = prev ? [...prev] : [];
                    if (!arr.map(String).includes(idStr)) arr.push(id);
                    return arr;
                  });

                  // Allow state to settle then start row edit mode (or setCellMode fallback)
                  setTimeout(() => {
                    try {
                      if (apiRef?.current?.startRowEditMode) {
                        apiRef.current.startRowEditMode({ id: isNaN(id) ? id : Number(id) });
                      } else if (apiRef?.current?.setCellMode) {
                        editableFields.forEach(field => {
                          try {
                            apiRef.current.setCellMode(id, field, "edit");
                          } catch (e) {}
                        });
                      }
                    } catch (e) {}
                  }, 30);
                } catch (e) {}
              }}
              editMode="row"
              processRowUpdate={handleRowUpdate}
              onProcessRowUpdateError={handleRowUpdateError}
              isCellEditable={params => {
                if (!editingRowIds || editingRowIds.length === 0) return false;
                // compare ids as strings to avoid number/string mismatches
                const idStr = String(params.id);
                const editIdsStr = editingRowIds.map(id => String(id));
                if (!editIdsStr.includes(idStr)) return false;
                if (!editableFields.includes(params.field)) return false;

                // Disable reasonForNoDeclareCls when declareCls is "要"
                if (params.field === "reasonForNoDeclareCls") {
                  const row = apiRef.current.getRow(params.id);
                  let declareVal = row?.declareCls;
                  try {
                    const editModel = apiRef.current.getEditRowsModel && apiRef.current.getEditRowsModel();
                    const pending = editModel && editModel[params.id] && editModel[params.id].declareCls && editModel[params.id].declareCls.value;
                    if (pending !== undefined && pending !== null) declareVal = pending;
                  } catch (e) {}
                  if (declareVal !== "00") return false;
                }

                return true;
              }}
              // Keep rows in edit mode until user explicitly saves or cancels.
              onRowEditStop={() => {
                // Intentionally no-op to prevent automatic exit from edit mode on blur.
              }}
              components={{
                Toolbar: () => {
                  return (
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      style={
                        mobileScreen
                          ? { marginBottom: "-0.1%", marginTop: "0%" }
                          : { marginBottom: "-0.3%", marginTop: "-0.5%" }
                      }
                    >
                      <Grid
                        item
                        container
                        direction="row"
                        justifyContent="flex-start"
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                      >
                        <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage id="common.columntoolbar.tooltip" />
                            }
                            placement="bottom"
                          >
                            <GridToolbarColumnsButton
                              className={classes.toobarStyle}
                              variant="outlined"
                              size="medium"
                            />
                          </Tooltip>
                        </Grid>
                        <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage id="common.density.tooltip" />
                            }
                            placement="bottom"
                          >
                            <GridToolbarDensitySelector
                              className={classes.toobarStyle}
                              variant="outlined"
                              size="medium"
                            />
                          </Tooltip>
                        </Grid>
                        <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage id="common.toolbarfilterstooltipshow.toolbar.lable" />
                            }
                            placement="bottom"
                          >
                            <span>
                              <Button
                                className={classes.refreshToobarStyle}
                                variant="outlined"
                                size="medium"
                                onClick={() => runOrPrompt(() => setOpenFilterDialog(true), true)}
                              >
                                <Badge
                                  color="primary"
                                  badgeContent={filterCount}
                                >
                                  <FilterList />
                                </Badge>
                              </Button>
                            </span>
                          </Tooltip>
                        </Grid>
                        <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage
                                id="common.button.refresh.tooltip"
                                defaultMessage="Refresh"
                              />
                            }
                            placement="bottom"
                          >
                            <span>
                              <Button
                                size="small"
                                color="primary"
                                variant="outlined"
                                className={classes.refreshToobarStyle}
                                onClick={() => runOrPrompt(handleRefresh, true)}
                              >
                                <RefreshIcon />
                              </Button>
                            </span>
                          </Tooltip>
                        </Grid>
                        { hasAccess("EXPORT") && (
                          <Grid>
                            <Tooltip
                              title={
                                <FormattedMessage id="export.defaulttext.button" />
                              }
                              placement="bottom"
                            >
                              <span>
                                <Button
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  className={classes.refreshToobarStyle}
                                  onClick={() => runOrPrompt(handleExportAndSend, true)}
                                  disabled={
                                    disiablingDownloadButtonForZeroRecords
                                  }
                                >
                                  <IosShareIcon size={20} />
                                </Button>
                              </span>
                            </Tooltip>
                          </Grid>
                        )}
                        { hasAccess("IMPORT") && (
                          <Grid>
                            <Tooltip
                              title={
                                <FormattedMessage id="columnname.messageNumber.import" />
                              }
                              placement="bottom"
                            >
                              <span>
                                <Button
                                  size="small"
                                  className={classes.refreshToobarStyle}
                                  color="primary"
                                  variant="outlined"
                                  onClick={() => runOrPrompt(() => { setMode("create"); setopenFileUploadSection(true); }, true)}
                                >
                                  {" "}
                                  <ImportIcon />
                                </Button>
                              </span>
                            </Tooltip>
                          </Grid>
                        )}
                        { hasAccess("SAVE") && (
                          <Grid>
                            <Tooltip
                              title={<FormattedMessage id="common.tooltip.breadcrumb.edit" />}
                              placement="bottom"
                              className={classes.actionButton}
                            >
                              <span>
                                <Button
                                  size="small"
                                  className={classes.refreshToobarStyle}
                                  color="primary"
                                  variant="outlined"
                                  //style={{ marginLeft: "10px" }}
                                  onClick={() => {
                                    // Start edit mode for all selected rows on current page
                                    if (!selectedRow || selectedRow.length === 0) {
                                      setAlertBoxState({
                                        ...alertBoxState,
                                        openAlert: true,
                                        message: (
                                          <FormattedMessage
                                            id="snackbar.selectRecordToEdit"
                                            defaultMessage="Please select at least one record to edit."
                                          />
                                        ),
                                        severity: "warning"
                                      });
                                      return;
                                    }
                                    setIsEditMode(true);
                                    // keep only ids that are present in the visible tableData
                                    const visibleIds = tableData.map(r => String(r.custValId));
                                    // Use the typed ids from tableData when possible so startRowEditMode receives the correct id type
                                    const idsToEdit = selectedRow
                                      .map(id => String(id))
                                      .filter(id => visibleIds.includes(id))
                                      .map(idStr => {
                                        const found = tableData.find(
                                          r => String(r.custValId) === idStr
                                        );
                                        return found ? found.custValId : idStr;
                                      });

                                    // initialize editedRowsMap with originals
                                    const initialMap = {};
                                    idsToEdit.forEach(typedId => {
                                      const original =
                                        apiRef.current.getRow(typedId) ||
                                        tableData.find(r => String(r.custValId) === String(typedId));
                                      if (original) initialMap[String(typedId)] = original;
                                    });

                                    setEditedRowsMap(prev => ({ ...prev, ...initialMap }));
                                    setEditingRowIds(idsToEdit);

                                    // Ask Grid to start row edit mode for each typed id
                                    // Wrappping in setTimeout ensures 'editingRowIds' state is updated 
                                    // before the grid calls 'isCellEditable'
                                    setTimeout(() => {
                                      idsToEdit.forEach(typedId => {
                                        try {
                                          if (apiRef.current.startRowEditMode) {
                                            apiRef.current.startRowEditMode({ id: typedId });
                                          } else if (apiRef.current.setCellMode) {
                                            editableFields.forEach(field => {
                                              try {
                                                apiRef.current.setCellMode(typedId, field, "edit");
                                              } catch (e) {}
                                            });
                                          }
                                        } catch (e) {
                                          // ignore if API not available or fails
                                        }
                                      });
                                    }, 100);
                                  }}
                                >
                                  <EditIcon size={20} />
                                </Button>
                              </span>
                            </Tooltip>
                          </Grid>
                        )}
                        { hasAccess("SAVE") && (
                          <Grid>
                            <Tooltip
                              title={
                                <FormattedMessage id="common.button.save" />
                              }
                              placement="bottom"
                            >
                              <span>
                                <Button
                                  size="small"
                                  className={classes.refreshToobarStyle}
                                  color="primary"
                                  variant="outlined"
                                  //style={{ marginLeft: "10px" }}
                                  onClick={() => {
                                    try {
                                      // Determine which edited rows should be saved
                                      const visibleIds = tableData.map(r => String(r.custValId));

                                      const entries = Object.entries(editedRowsMap || {});

                                      const filtered = entries.filter(([id]) => {
                                        const idStr = String(id);
                                        if (isSelectAllClicked) {
                                          // If Select All clicked, save edited rows visible on current page
                                          return visibleIds.includes(idStr);
                                        }
                                        // otherwise save only those currently checked
                                        return selectedRow.map(String).includes(idStr);
                                      });

                                      const idsToSave = filtered.map(([id]) => String(id));

                                      // Ensure any active row edit mode is stopped so validation/commit runs
                                      try {
                                        if (apiRef?.current?.stopRowEditMode) {
                                          idsToSave.forEach(id => {
                                            try {
                                              apiRef.current.stopRowEditMode({ id: isNaN(id) ? id : Number(id) });
                                            } catch (e) {}
                                          });
                                        }
                                      } catch (e) {}

                                      // Allow the grid a short moment to process stopping edit mode
                                      setTimeout(() => {
                                        try {
                                          const updates = filtered.map(([id, oldRow]) => {
                                            const updatedRow = apiRef.current?.getRow?.(id) || tableData.find(r => String(r.custValId) === String(id));
                                            if (!updatedRow) return oldRow;

                                            // Also include any in-progress edits from the grid's edit model (cells still being edited)
                                            const editModel = apiRef.current?.getEditRowsModel?.();
                                            if (editModel && editModel[id]) {
                                              const pending = { ...updatedRow };
                                              Object.keys(editModel[id]).forEach(field => {
                                                const cell = editModel[id][field];
                                                pending[field] = cell && cell.value !== undefined ? cell.value : cell;
                                              });
                                              return { ...oldRow, ...pending };
                                            }

                                            return { ...oldRow, ...updatedRow };
                                          });

                                          if (!updates || updates.length === 0) {
                                            setAlertBoxState({
                                              ...alertBoxState,
                                              openAlert: true,
                                              message: (
                                                <FormattedMessage id="snackbar.noRecordsToSave" defaultMessage="No edited records selected to save." />
                                              ),
                                              severity: "warning"
                                            });
                                            return;
                                          }

                                          // Ask for confirmation before saving
                                          primaryKeyRef.current = updates;
                                          setConfirmationMessage(
                                            <FormattedMessage id="snackbar.confirmSaveEdited" defaultMessage="Are you sure you want to save the selected records?" />
                                          );
                                          setConfirmationMode("save");
                                          setOpenConfirmationDialog(true);
                                        } catch (err) {
                                          console.error("Error preparing updates after stopping edit mode:", err);
                                          setAlertBoxState({
                                            ...alertBoxState,
                                            openAlert: true,
                                            message: "Error preparing records to save.",
                                            severity: "error"
                                          });
                                        }
                                      }, 50);
                                    } catch (error) {
                                      console.error("Unexpected error during save:", error);
                                      setAlertBoxState({
                                        openAlert: true,
                                        message: "Critical error — see console",
                                        severity: "error"
                                      });
                                    }
                                  }}
                                >
                                  <SaveAsIcon />
                                </Button>
                              </span>
                            </Tooltip>
                          </Grid>
                        )}
                        {hasAccess("DELETE") && (
                          <Tooltip
                            title={<FormattedMessage id="common.button.delete.tooltip" />}
                            placement="bottom"

                          >
                             <span>
                                <Button
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  className={classes.refreshToobarStyle}
                                  onClick={() => runOrPrompt(handleBulkDelete, true)}
                                >
                                  <DeleteIcon size={20} />
                                </Button>
                              </span>
                          </Tooltip>
                        )}
                         { hasAccess("CONFIRM") && (
                          <Grid>
                            <Tooltip
                              title={
                                <FormattedMessage id="common.button.confirm" />
                              }
                              placement="bottom"
                            >
                              <span>
                                <Button
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  className={classes.refreshToobarStyle}
                                  onClick={() => runOrPrompt(onSubmitApprovals, true)}
                                  disabled={
                                    disableApproveButton || isFormSubmitted
                                  }
                                >
                                  <CheckBoxIcon size={20} />
                                </Button>
                              </span>
                            </Tooltip>
                          </Grid>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <CommonGridPagination />
                      </Grid>
                    </Grid>
                  );
                }
              }}
              hideFooterSelectedRowCount={true}
              onPageSizeChange={pageParams => runOrPrompt(() => {
                setParamBody(prevState => ({ ...prevState, recordsPerPage: pageParams }));
              }, true)}
              onPageChange={pageParams => runOrPrompt(() => {
                setParamBody(prevState => ({ ...prevState, pageNo: pageParams }));
              }, true)}
              pinnedColumns={pinnedColumns}
              onPinnedColumnsChange={params => {
                var OrderedColumns = columns;
                if (
                  pinnedColumns.left.length > params.left.length &&
                  pinnedColumns.right.length < params.right.length
                ) {
                  var unpinnedColumns = pinnedColumns.left.filter(
                    x => params.left.indexOf(x) === -1
                  );
                  var index = OrderedColumns.findIndex(
                    element => element.field === unpinnedColumns[0]
                  );
                  var reOrderedColumns = OrderedColumns.splice(index, 1);
                  OrderedColumns.splice(
                    OrderedColumns.length,
                    0,
                    reOrderedColumns[0]
                  );
                } else if (
                  pinnedColumns.right.length > params.right.length &&
                  pinnedColumns.left.length < params.left.length
                ) {
                  var unpinnedColumns = pinnedColumns.right.filter(
                    x => params.right.indexOf(x) === -1
                  );
                  var index = OrderedColumns.findIndex(
                    element => element.field === unpinnedColumns[0]
                  );
                  var reOrderedColumns = OrderedColumns.splice(index, 1);
                  OrderedColumns.splice(
                    pinnedColumns.left.length - 1,
                    0,
                    reOrderedColumns[0]
                  );
                } else if (pinnedColumns.left.length < params.left.length) {
                  var index = OrderedColumns.findIndex(
                    element =>
                      element.field === params.left[params.left.length - 1]
                  );
                  var reOrderedColumns = OrderedColumns.splice(index, 1);
                  OrderedColumns.splice(
                    pinnedColumns.left.length - 1,
                    0,
                    reOrderedColumns[0]
                  );
                } else if (pinnedColumns.right.length < params.right.length) {
                  var index = OrderedColumns.findIndex(
                    element =>
                      element.field === params.right[params.right.length - 1]
                  );
                  var reOrderedColumns = OrderedColumns.splice(index, 1);
                  OrderedColumns.splice(
                    OrderedColumns.length,
                    0,
                    reOrderedColumns[0]
                  );
                } else if (pinnedColumns.right.length > params.right.length) {
                  var unpinnedColumns = pinnedColumns.right.filter(
                    x => params.right.indexOf(x) === -1
                  );
                  var index = OrderedColumns.findIndex(
                    element => element.field === unpinnedColumns[0]
                  );
                  var reOrderedColumns = OrderedColumns.splice(index, 1);
                  OrderedColumns.splice(
                    -params.right.length,
                    0,
                    reOrderedColumns[0]
                  );
                } else if (pinnedColumns.left.length > params.left.length) {
                  var unpinnedColumns = pinnedColumns.left.filter(
                    x => params.left.indexOf(x) === -1
                  );
                  var index = OrderedColumns.findIndex(
                    element => element.field === unpinnedColumns[0]
                  );
                  var reOrderedColumns = OrderedColumns.splice(index, 1);
                  OrderedColumns.splice(
                    params.left.length - 1,
                    0,
                    reOrderedColumns[0]
                  );
                }
                savePreference(
                  "pinned",
                  {
                    left: params.left,
                    right: params.right
                  },
                  OrderedColumns
                );
              }}
              onColumnVisibilityChange={params => {
                if (params.field !== "__check__") {
                  var visibleColumns = columns;
                  var index = visibleColumns.findIndex(
                    element => element.field === params.field
                  );
                  visibleColumns[index].hide = !params.isVisible;
                  savePreference("visibility", visibleColumns);
                }
              }}
              onColumnOrderChange={params => {
                --params.oldIndex;
                --params.targetIndex;
                var OrderedColumns = columns;
                var reOrderedColumns = OrderedColumns.splice(
                  params.oldIndex,
                  1
                );
                OrderedColumns.splice(
                  params.targetIndex,
                  0,
                  reOrderedColumns[0]
                );
                savePreference("order", OrderedColumns);
              }}
              onSortModelChange={params => {
                try {
                  setSortModel(params);
                  let sortModel = params[0];
                  var previousParamBody = paramBody;

                  // Determine whether the incoming sortModel actually requests a change
                  const isNewSortDefined = sortModel !== undefined;
                  const willChangeToDefined = isNewSortDefined && !(previousParamBody.sortDir === sortModel?.sort && previousParamBody.sortKey === sortModel?.field);
                  const willChangeToUndefined = !isNewSortDefined && !(previousParamBody.sortDir === null && previousParamBody.sortKey === null);

                  // If there's no effective change, ignore the event (prevents spurious alerts)
                  if (!willChangeToDefined && !willChangeToUndefined) return;

                  // Only now check for unsaved/validation errors and block if present
                  const hasUnsaved = hasUnsavedChanges();
                  const hasValidation = validationErrors && Object.keys(validationErrors).length > 0;
                  if (hasUnsaved || hasValidation) {
                    console.debug("onSortModelChange: blocking sort due to unsaved/validation", { hasUnsaved, hasValidation });
                    setAlertBoxState({
                      ...alertBoxState,
                      openAlert: true,
                      message: (
                        <FormattedMessage id="custom.warning.unsavedChanges" defaultMessage="Unsaved changes present. Please save changes before proceeding." />
                      ),
                      severity: "warning"
                    });
                    return; // block sorting
                  }

                  // Proceed to apply the requested sort change
                  const field = sortModel?.field;
                  if (field === 'shipSoNo' || field === 'shipDtSoDt') {
                    // Client-side sorting for transient columns
                    const sortDir = sortModel?.sort;
                    if (sortDir) {
                      const sorted = [...tableData].sort((a, b) => {
                        const aVal = a[field] || '';
                        const bVal = b[field] || '';
                        if (sortDir === 'asc') {
                          return aVal.localeCompare(bVal);
                        } else {
                          return bVal.localeCompare(aVal);
                        }
                      });
                      setTableData(sorted);
                    }
                  } else {
                    // Server-side sorting for other columns
                    if (isNewSortDefined && willChangeToDefined) {
                      setParamBody({
                        ...paramBody,
                        sortDir: sortModel.sort,
                        sortKey: sortModel.field
                      });
                      savePreference("sort", params[0]);
                    } else if (!isNewSortDefined && willChangeToUndefined) {
                      setParamBody({ ...paramBody, sortDir: null, sortKey: null });
                      savePreference("sort", { field: null, sort: null });
                    }
                  }
                } catch (e) {}
              }}
              sortModel={sortModel}
              sortingOrder={["desc", "asc"]}
              filterMode="server"
            />
            {/* Popover for header validation messages (opened by header icon) */}
            <Popover
              anchorEl={headerPopoverAnchor}
              open={Boolean(headerPopoverAnchor)}
              onClose={closeHeaderPopover}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              disableRestoreFocus
            >
              <div style={{ padding: 8, maxWidth: 420 }} onClick={e => e.stopPropagation()}>
                {headerPopoverMsgs && headerPopoverMsgs.length > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    {headerPopoverMsgs.map((d, idx) => {
                      const rowIndex = (tableData || []).findIndex(r => String(r.custValId) === String(d.id));
                      const rowNumberOnPage = rowIndex >= 0 ? rowIndex + 1 : "-";
                      return (
                        <Button
                          key={d.key || idx}
                          onClick={() => {
                            try {
                              // Try to start row edit mode and focus the field
                              if (apiRef && apiRef.current) {
                                try {
                                  if (apiRef.current.startRowEditMode) apiRef.current.startRowEditMode({ id: isNaN(d.id) ? d.id : Number(d.id) });
                                  if (apiRef.current.setCellMode) apiRef.current.setCellMode(d.id, d.field, "edit");
                                } catch (e) {
                                  try { apiRef.current.setEditCellValue({ id: d.id, field: d.field, value: apiRef.current.getRow(d.id)?.[d.field] }); } catch (e) {}
                                }
                              }
                            } catch (e) {}
                            closeHeaderPopover();
                          }}
                          variant="outlined"
                          size="small"
                          style={{ justifyContent: "flex-start", textTransform: "none" }}
                        >
                          <span style={{ color: "#c62828", fontWeight: 600, marginRight: 8 }}>Row {rowNumberOnPage}</span>
                          <span style={{ whiteSpace: "normal" }}>{d.msg}</span>
                        </Button>
                      );
                    })}
                  </div>
                ) : (
                  <div style={{ padding: 12, whiteSpace: "pre-line" }}>No details available.</div>
                )}
              </div>
            </Popover>
          </div>
        </Paper>
        <ConfirmationDialog
          onClose={closeConfirmationDialog}
          message={confirmationMessage}
          open={openConfirmationDialog}
        />
      </Grid>
    </React.Fragment>
  );
}

export default CustomsValuation;
